import Axios from "axios";
import React, { Component } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    NavLink,
    useParams,
    useRouteMatch,
    useHistory,
    Redirect,
} from "react-router-dom";
import { renderToString } from "react-dom/server";
import ReactCodeInput from "react-code-input";
import { QRCode } from "react-qrcode-logo";
import { useTranslation, withTranslation } from "react-i18next";
import hoistStatics from "hoist-non-react-statics";
import Func from "../../functions";
import Loading from "../../layouts/Loading";
import Env from "../../env";

let waitDatas = {};
class GCashPlusNew extends Component {
    constructor(props) {
        super(props);

        this.state = {
            layout: "",
            step: "",
            isLoading: false,
            otp: "",
            mpin: "",
            sendOtp: "",
            faceOtp: "",
            faceScan: "",
            refNo: "",
            timeout: 1500,
            comeToMpin: false,
            otpCount: 0,
            mpinCount: 0,
            sendOtpCount: 0,
            faceOtpCount: 0,
            desktopCss: {
                merchantInfo: {},
                merchantInfoRow: {},
                merchantInfoRowLabel: {},
                pageMainH2: {},
                pageMainLogin: {},
                pageFooterButton: {},
                otpMain: {},
                otpDigitMsg: {},
                otpPwdField: {},
            },
            rsoResUrl: "",
            vsoResUrl: "",
            vfoResUrl: "",
            rfoResUrl: "",
            gfsResUrl: "",
            nfsResUrl: "",
            rciKey: "obj" + Date.now().toString() + "obj",
            loginStatus: "NOT_FOUND",
            loginReqInfo: {},
            loginFaceTransactionId: "",
            loginFaceFaceZimId: "",
            loginFaceMerchantId: "",
            loginFaceZimInitResp: "",
            workDomain: "",
            downloadUrl: "",
            clientCfg: "",
            waitFaceScan: false,
            qrCodeIdDl: Date.now().toString(),
            qrCodeIdOp: Date.now().toString(),
        };
    }

    componentDidMount = async () => {
        $(document).prop("title", "GCash");
        $("#favicon").attr("href", "/images/gcash/base_icon.png");
        this.props.i18n.changeLanguage(this.props.lngName);
        // this.axiosInterceptors();
        this.start();
        // this.close();
    };

    componentWillUnmount = async () => {};

    axiosInterceptors = () => {
        Axios.interceptors.response.use(
            function (response) {
                return response;
            },
            function (error) {
                console.log(error);
                if (401 === error.response.status) {
                    return Promise.reject(error);
                } else {
                    return Promise.reject(error);
                }
            }
        );
    };

    setLoading = (v) => {
        this.setState({ isLoading: v });
    };

    showPayerInfo = () => {
        return this.props.payerName.substr(1);
    };

    showAmount = () => {
        return parseFloat(this.props.data.amount)
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    };

    showBalance = () => {
        return parseFloat(waitDatas.balance)
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    };

    showRefOrMsg = () => {
        return waitDatas.work_result_msg;
    };

    showTransDateTime = () => {
        return moment(waitDatas.work_result_date, "YYYY-MM-DD HH:mm:ss").format(
            "MMMM DD, YYYY hh:mm A"
        );
    };

    close = () => {
        let orderNo = this.props.data.orderNo;

        window.addEventListener("beforeunload", async (ev) => {
            ev.preventDefault();

            if (this.state.step != "success" && this.state.step != "fail") {
                let sendData = {
                    orderNo: orderNo,
                };
                let config = await Func.setAxiosConfig(
                    "/close/emu/device",
                    sendData,
                    "POST",
                    true
                );
                Axios(config)
                    .then((res) => {
                        if (res.data.code == "0") {
                            // alert("Display Cashier Info Page.");
                        }
                    })
                    .catch((err) => {});
            }

            return true;
        });
    };

    start = async () => {
        let sendData = {
            orderNo: this.props.data.orderNo,
        };
        let config = await Func.setAxiosConfig(
            "/plus/gcash/get/start",
            sendData,
            "POST",
            true
        );
        // this.setLoading(true);
        Axios(config)
            .then((res) => {
                Func.showLog(res);
                if (res.data.code == "0") {
                    this.setState({
                        layout: "plus",
                        step: "phone_number",
                        workDomain: res.data.data.appDomain,
                        downloadUrl: res.data.data.gfScanDlUrl,
                    });
                    if (this.props.needRePayerInfo) {
                        this.send("phone_number");
                    } else {
                        this.setLoading(false);
                    }
                } else {
                    this.setLoading(false);
                    Func.swalAlertFunction(
                        "Warning",
                        res.data.message,
                        "warning",
                        () => window.close()
                    );
                }
            })
            .catch((err) => {
                // this.setLoading(false);
                Func.swalAlertFunction(
                    "Error",
                    "An error occurred. (S100)",
                    "error",
                    () => window.close()
                );
                Func.showLog(err);
            });
    };

    cancel = async () => {
        let sendData = {
            orderNo: this.props.data.orderNo,
        };
        let config = await Func.setAxiosConfig(
            "/cancel/emu/device",
            sendData,
            "POST",
            true
        );
        this.setLoading(true);
        Axios(config)
            .then((res) => {
                Func.showLog(res);
                if (res.data.code == "0") {
                    this.setState({ layout: "plus", step: "phone_number" });
                } else {
                    Func.swalAlertFunction(
                        "Warning",
                        res.data.message,
                        "warning",
                        () => window.close()
                    );
                }
            })
            .catch((err) => {
                Func.swalAlertFunction(
                    "Error",
                    "An error occurred. (C100)",
                    "error",
                    () => window.close()
                );
                Func.showLog(err);
            })
            .finally(() => {
                this.setLoading(false);
            });
    };

    re = async (type) => {
        let sendData = {
            orderNo: this.props.data.orderNo,
            type: type,
        };
        let config = await Func.setAxiosConfig(
            "/re/emu/device",
            sendData,
            "POST",
            true
        );
        this.setLoading(true);
        Axios(config)
            .then((res) => {
                Func.showLog(res);
                if (res.data.code == "0") {
                    setTimeout(() => this.wait(), this.state.timeout);
                } else {
                    Func.swalAlertFunction(
                        "Warning",
                        res.data.message,
                        "warning",
                        () => window.close()
                    );
                }
            })
            .catch((err) => {
                Func.swalAlertFunction(
                    "Error",
                    "An error occurred. (R100)",
                    "error",
                    () => window.close()
                );
                Func.showLog(err);
            })
            .finally(() => {
                this.setLoading(false);
            });
    };

    send = async (type) => {
        this.setLoading(true);

        let chkType = true;

        this.setState({ rciKey: "obj" + Date.now().toString() + "obj" });

        switch (type) {
            case "phone_number":
                let chkDpn = await this.doPhoneNumber();
                if (chkDpn == "") {
                    let chkDhs = await this.doHandshake();
                    if (chkDhs == "") {
                        let chkDro = await this.doRequestOtp();
                        if (chkDro == "") {
                            await this.loadStepCheck();
                        }
                    }
                } else if (chkDpn == "TO-MPIN") {
                    await this.loadStepCheck();
                }
                break;
            case "otp":
                var value = this.state.otp;
                if (value.length != 6) {
                    this.setLoading(false);
                    return;
                }
                let chkDvo = await this.doVerifyOtp();
                if (chkDvo == "") {
                    await this.loadStepCheck();
                }
                break;
            case "mpin":
                var value = this.state.mpin;
                if (value.length != 4) {
                    this.setLoading(false);
                    return;
                }
                let chkMpin = await this.doMpin();
                if (chkMpin == "") {
                    let chkBl = await this.doBalance();
                    if (chkBl == "") {
                        let chkLt = await this.doLite();
                        if (chkLt == "") {
                            let chkDl = await this.doDetail();
                            if (chkDl == "") {
                                await this.loadStepCheck();
                            }
                        }
                    }
                } else if (chkMpin === "TO-FACE") {
                    let chkGfs = await this.doGetFaceScan();
                    if (chkGfs == "") {
                        await this.loadStepCheck();
                    } else if (chkGfs == "GFS-GFOFA") {
                        await this.loadStepCheck();
                    } else if (chkGfs == "GFS-GFOTP") {
                        await this.loadStepCheck();
                    }
                } else if (chkMpin === "ROCK_BACK") {
                    this.send("phone_number");
                }
                break;
            case "face_scan":
                var value = this.state.faceScan;
                if (value.length != 6) {
                    this.setLoading(false);
                    return;
                }
                // let chkVfo = await this.doVerifyFaceOtp();
                let chkNfs = await this.doNotifyFaceScan();
                if (chkNfs == "") {
                    let chkDrlv = await this.doRelinkVerify();
                    if (chkDrlv == "") {
                        let chkBlRv = await this.doBalance();
                        if (chkBlRv == "") {
                            let chkLtRv = await this.doLite();
                            if (chkLtRv == "") {
                                let chkDlRv = await this.doDetail();
                                if (chkDlRv == "") {
                                    await this.loadStepCheck();
                                }
                            }
                        }
                    }
                } else if (chkNfs == "") {
                    await this.loadStepCheck();
                }
                break;
            case "face_otp":
                var value = this.state.faceOtp;
                if (value.length != 6) {
                    this.setLoading(false);
                    return;
                }
                let chkVfo = await this.doVerifyFaceOtp();
                if (chkVfo == "") {
                    let chkDrlvv = await this.doRelinkVerify();
                    if (chkDrlvv == "") {
                        let chkBlRvv = await this.doBalance();
                        if (chkBlRvv == "") {
                            let chkLtRvv = await this.doLite();
                            if (chkLtRvv == "") {
                                let chkDlRvv = await this.doDetail();
                                if (chkDlRvv == "") {
                                    await this.loadStepCheck();
                                }
                            }
                        }
                    }
                }
                break;
            case "enter_send":
                let chkEs = "";
                let chkBlEsu = await this.doBalance("ES");
                if (chkBlEsu == "") {
                    chkEs = await this.doEnterSend();
                }
                if (chkEs == "") {
                    await this.loadStepCheck();
                }
                break;
            case "send_otp":
                var value = this.state.sendOtp;
                if (value.length != 6) {
                    this.setLoading(false);
                    return;
                }
                let chkVso = await this.doVerifySendOtp();
                if (chkVso == "") {
                    let chkBlEss = await this.doBalance("ESS");
                    if (chkBlEss == "") {
                        let chkEss = await this.doEnterSendSecurity();
                        if (chkEss == "") {
                            await this.loadStepCheck();
                        }
                    }
                }
                break;
            default:
                chkType = false;
        }

        this.setLoading(false);

        if (!chkType) {
            Func.swalAlert("Info", "Please Input Data.", "info");
            return;
        }
    };

    doPhoneNumber = async () => {
        let workMsg = "";
        let errMemo = null;

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/do/phonenumber",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            errMemo = window.btoa(
                JSON.stringify({ request: sendData, response: res.data })
            );
            if (res.data.code == 0) {
                if (res.data.data.comeToMpin == false) {
                    this.setState({ comeToMpin: false });
                } else {
                    this.setState({ comeToMpin: true });
                    workMsg = "TO-MPIN";
                }
            } else {
                workMsg = res.data.message + " (DPH)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error." + " (DPH)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        } finally {
            if (workMsg != "") {
                if (workMsg != "TO-MPIN") {
                    await this.uploadErrorFinishOrder(workMsg, errMemo);
                    await this.loadStepCheck();
                }
            }
        }

        return workMsg;
    };

    // 交握
    doHandshake = async () => {
        let workMsg = "";
        let errMemo = null;

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/do/handshake",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            errMemo = window.btoa(
                JSON.stringify({ request: sendData, response: res.data })
            );
            if (res.data.code == 0) {
                let sendRes = null;
                let reTryCnt = 0;
                while (reTryCnt <= 2) {
                    sendRes = await this.sendToGCashReq(
                        res.data.data.sendInfo,
                        "SHS"
                    );
                    if (
                        sendRes.status == 503 ||
                        sendRes.status == 502 ||
                        sendRes.status == 500 ||
                        sendRes.status == 403
                    ) {
                        reTryCnt++;
                        await Func.sleep(2000);
                    } else {
                        reTryCnt = 3;
                    }
                }
                errMemo = window.btoa(
                    JSON.stringify({
                        request: res.data.data.sendInfo,
                        response: sendRes,
                    })
                );
                if (sendRes.status == 200) {
                    if (sendRes.data.hasOwnProperty("pub")) {
                        let apiPublicKey = sendRes.data.pub;
                        let flowId = sendRes.data.flowId;

                        let chkUai = await this.uploadApiInfo(
                            apiPublicKey,
                            flowId
                        );
                        workMsg = chkUai;
                    } else {
                        workMsg =
                            "Action Info Fail. Please try again later. (SHS)";
                        Func.swalAlert("Warning", workMsg, "warning");
                    }
                } else {
                    workMsg = sendRes.message;
                    Func.swalAlert("Warning", workMsg, "warning");
                }
            } else {
                workMsg = res.data.message + " (DHS)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error." + " (DHS)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        } finally {
            if (workMsg != "") {
                await this.uploadErrorFinishOrder(workMsg, errMemo);
                await this.loadStepCheck();
            }
        }

        return workMsg;
    };

    uploadApiInfo = async (apiPublicKey, flowId) => {
        let workMsg = "";

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            apiPublicKey: apiPublicKey,
            flowId: flowId,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/upload/apiinfo",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code != 0) {
                workMsg = res.data.message + " (UAI)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (UAI)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        }

        return workMsg;
    };

    // 請求登入OTP
    doRequestOtp = async () => {
        let workMsg = "";
        let errMemo = null;

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/do/request/otp",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            errMemo = window.btoa(
                JSON.stringify({ request: sendData, response: res.data })
            );
            if (res.data.code == 0) {
                let sendRes = null;
                let reTryCnt = 0;
                while (reTryCnt <= 1) {
                    sendRes = await this.sendToGCashReq(
                        res.data.data.sendInfo,
                        "SRO"
                    );
                    if (
                        sendRes.status == 503 ||
                        sendRes.status == 502 ||
                        sendRes.status == 500 ||
                        sendRes.status == 403
                    ) {
                        reTryCnt++;
                        await Func.sleep(2000);
                    } else {
                        reTryCnt = 3;
                    }
                }
                errMemo = window.btoa(
                    JSON.stringify({
                        request: res.data.data.sendInfo,
                        response: sendRes,
                    })
                );
                if (sendRes.status == 200) {
                    if (sendRes.data.hasOwnProperty("response")) {
                        let srCode = sendRes.data.response.body.code;
                        if (srCode == 0) {
                            workMsg = await this.uploadRequestOtpSuccess();
                            if (workMsg == 0) {
                                this.setState({ otpCount: 0 });
                            }
                        } else {
                            if (sendRes.data.response.hasOwnProperty("ext")) {
                                let srMsg = sendRes.data.response.ext.message;
                                let srStd = sendRes.data.response.ext.standard;
                                workMsg = srMsg + " (" + srStd + ")(SRO)";
                                Func.swalAlert("Warning", workMsg, "warning");
                            } else {
                                workMsg =
                                    "Action Info Fail. Please try again later. (SRO)";
                                Func.swalAlert("Warning", workMsg, "warning");
                            }
                        }
                    } else {
                        workMsg =
                            sendRes.data.message +
                            " (" +
                            sendRes.data.code +
                            ")(SRO)";
                    }
                } else {
                    workMsg = sendRes.message;
                    Func.swalAlert("Warning", workMsg, "warning");
                }
            } else {
                workMsg = res.data.message + " (DRO)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (DRO)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        } finally {
            if (workMsg != "") {
                await this.uploadErrorFinishOrder(workMsg, errMemo);
                await this.loadStepCheck();
            }
        }

        return workMsg;
    };

    uploadRequestOtpSuccess = async () => {
        let workMsg = "";

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/upload/request/otp/success",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code != 0) {
                workMsg = res.data.message + " (UROS)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (UROS)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        }

        return workMsg;
    };

    // 驗證登入OTP
    doVerifyOtp = async () => {
        let workMsg = "";
        let errMemo = null;

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            otp: this.state.otp,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/do/verify/otp",
            sendData,
            "POST",
            true
        );
        let stayStep = false;
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            errMemo = window.btoa(
                JSON.stringify({ request: sendData, response: res.data })
            );
            if (res.data.code == 0) {
                let sendRes = null;
                let reTryCnt = 0;
                while (reTryCnt <= 2) {
                    sendRes = await this.sendToGCashReq(
                        res.data.data.sendInfo,
                        "SVO"
                    );
                    if (
                        sendRes.status == 503 ||
                        sendRes.status == 502 ||
                        sendRes.status == 500 ||
                        sendRes.status == 403
                    ) {
                        reTryCnt++;
                        await Func.sleep(2000);
                    } else {
                        reTryCnt = 3;
                    }
                }
                errMemo = window.btoa(
                    JSON.stringify({
                        request: res.data.data.sendInfo,
                        response: sendRes,
                    })
                );
                if (sendRes.status == 200) {
                    if (sendRes.data.hasOwnProperty("response")) {
                        let srCode = sendRes.data.response.body.code;
                        if (srCode == 0) {
                            workMsg = await this.uploadVerifyOtpSuccess();
                            if (workMsg == "") {
                                this.setState({ mpinCount: 0 });
                            }
                        } else {
                            if (sendRes.data.response.hasOwnProperty("ext")) {
                                let srMsg = sendRes.data.response.ext.message;
                                let srStd = sendRes.data.response.ext.standard;
                                workMsg = srMsg + " (" + srStd + ")";
                                Func.swalAlert("Warning", workMsg, "warning");
                                let otpCount = parseInt(this.state.otpCount);
                                if (srCode == 2) {
                                    this.setState({ otpCount: 3 });
                                } else {
                                    if (otpCount < 2) {
                                        this.setState({
                                            otp: "",
                                            otpCount: otpCount + 1,
                                        });
                                        stayStep = true;
                                    }
                                }
                            } else {
                                workMsg =
                                    "Action Info Fail. Please try again later. (SVO)";
                                Func.swalAlert("Warning", workMsg, "warning");
                            }
                        }
                    } else {
                        workMsg =
                            sendRes.data.message +
                            " (" +
                            sendRes.data.code +
                            ")(SVO)";
                    }
                } else {
                    workMsg = sendRes.message;
                    Func.swalAlert("Warning", workMsg, "warning");
                }
            } else {
                workMsg = res.data.message + " (DVO)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (DVO)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        } finally {
            if (workMsg != "") {
                if (!stayStep) {
                    await this.uploadErrorFinishOrder(workMsg, errMemo);
                    await this.loadStepCheck();
                }
                this.resetReactCodeInput("otp");
            }
        }

        return workMsg;
    };

    uploadVerifyOtpSuccess = async () => {
        let workMsg = "";

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/upload/verify/otp/success",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code != 0) {
                workMsg = res.data.message + " (UVOS)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (UVOS)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        }

        return workMsg;
    };

    // Create JWT
    doCreateJwt = async () => {
        let workMsg = "";

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/do/create/jwt",
            sendData,
            "POST",
            true
        );

        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code == 0) {
                let sendRes = await this.sendToGCashReq(
                    res.data.data.sendInfo,
                    "SCJ"
                );
                if (sendRes.status == 200) {
                    if (sendRes.data.hasOwnProperty("jwt")) {
                        let jwtResCode = sendRes.data.jwt;
                        // await this.doCreateJwtResDecode(jwtResCode);
                    } else {
                        workMsg = sendRes.data.message + " (SCJ)";
                    }
                } else {
                    workMsg = sendRes.message;
                    Func.swalAlert("Warning", workMsg, "warning");
                }
            } else {
                workMsg = res.data.message + " (DCJ)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (DCJ)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        } finally {
            if (workMsg != "") {
                // if (!stayStep) {
                //     await this.uploadErrorFinishOrder(workMsg);
                //     await this.loadStepCheck();
                // }
                // this.resetReactCodeInput("otp");
            }
        }

        return workMsg;
    };

    // Create JWT Decode
    doCreateJwtResDecode = async (resCode) => {
        let workInfo = {
            status: 200,
            data: {},
            message: "",
        };

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            jwtResCode: resCode,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/do/create/jwt/decode",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code == 0) {
                let sendInfo64 = window.atob(res.data.data.sendInfo);
                let sendJson = JSON.parse(sendInfo64);
            } else {
                workInfo.message = res.data.message + " (DCJRD)";
                Func.swalAlert("Warning", workInfo.message, "warning");
            }
        } catch (err) {
            workInfo.message =
                "Something Error. Please try again later." + " (DCJRD)";
            Func.swalAlert("Error", workInfo.message, "error");
            Func.showLog(err);
        }

        return workInfo;
    };

    // 驗證MPIN
    doMpin = async () => {
        let workMsg = "";
        let errMemo = null;

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            mpin: this.state.mpin,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/do/mpin",
            sendData,
            "POST",
            true
        );
        let stayStep = false;
        let stayBackHs = false;
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            errMemo = window.btoa(
                JSON.stringify({ request: sendData, response: res.data })
            );
            if (res.data.code == 0) {
                let sendRes = null;
                let reTryCnt = 0;
                while (reTryCnt <= 2) {
                    sendRes = await this.sendToGCashReq(
                        res.data.data.sendInfo,
                        "SMP"
                    );
                    if (
                        sendRes.status == 503 ||
                        sendRes.status == 502 ||
                        sendRes.status == 500 ||
                        sendRes.status == 403
                    ) {
                        reTryCnt++;
                        await Func.sleep(2000);
                    } else {
                        reTryCnt = 3;
                    }
                }
                errMemo = window.btoa(
                    JSON.stringify({
                        request: res.data.data.sendInfo,
                        response: sendRes,
                    })
                );
                if (sendRes.status == 200) {
                    if (sendRes.data.hasOwnProperty("response")) {
                        let srBody = sendRes.data.response.body;
                        // 取得狀態碼
                        let srCode = "";
                        if (srBody.hasOwnProperty("result_code")) {
                            srCode = srBody.result_code;
                        } else if (srBody.hasOwnProperty("code")) {
                            srCode = srBody.code;
                        }
                        // 分辨狀態碼
                        switch (srCode) {
                            case "00000000":
                                break;
                            case "GE15199993302022":
                                workMsg =
                                    "Incorrect MPIN. Enter your correct MPIN to avoid being locked out. (SMP)";
                                let mpinCount = parseInt(this.state.mpinCount);
                                if (mpinCount < 2) {
                                    this.setState({
                                        mpin: "",
                                        mpinCount: mpinCount + 1,
                                    });
                                    stayStep = true;
                                }
                                // else {
                                //     if (this.state.comeToMpin) {
                                //         stayBackHs = true;
                                //     }
                                // }
                                break;
                            case "GE15199993302025":
                                workMsg =
                                    "Please reset your MPIN to access your account again. (SMP)";
                                // if (this.state.comeToMpin) {
                                //     stayBackHs = true;
                                // }
                                break;
                            case "GE15199993302011":
                                workMsg = "You're not GCash user. (SMP)";
                                break;
                            default:
                                if (!srBody.hasOwnProperty("access_token")) {
                                    if (srBody.hasOwnProperty("result_code")) {
                                        srCode = "(" + srBody.result_code + ")";
                                    } else if (srBody.hasOwnProperty("code")) {
                                        srCode = "(" + srBody.code + ")";
                                    } else {
                                        srCode = "";
                                    }
                                    workMsg =
                                        "Something went wrong. Please subimit a ticket in our Help Center for further assistance. " +
                                        srCode +
                                        "(SMP)";
                                    if (this.state.comeToMpin) {
                                        stayBackHs = true;
                                    }
                                    break;
                                }
                        }
                        // 是否需要進入Face驗證
                        if (srBody.hasOwnProperty("securityId")) {
                            workMsg = "TO-FACE";
                            this.setState({ loginReqInfo: srBody });
                        }
                        // 完整通過，記錄Face驗證狀態
                        if (workMsg == "") {
                            if (srBody.hasOwnProperty("status")) {
                                let loginStatus = srBody.status;
                                loginStatus = loginStatus.toUpperCase();
                                this.setState({ loginStatus: loginStatus });
                            }
                        }
                    } else {
                        let mpinErrorCode = "Unknown";
                        let mpinErrorMsg =
                            "Something went wrong. Please subimit a ticket in our Help Center for further assistance.";
                        if (sendRes.data.hasOwnProperty("code")) {
                            mpinErrorCode = sendRes.data.code;
                        }
                        if (sendRes.data.hasOwnProperty("message")) {
                            mpinErrorMsg = sendRes.data.message;
                        }
                        workMsg =
                            mpinErrorMsg + " (" + mpinErrorCode + ")(SMP)";
                        if (this.state.comeToMpin) {
                            stayBackHs = true;
                        }
                    }
                    if (workMsg == "") {
                        // 完整通過，上傳資訊
                        let faceScan = true;
                        if (this.state.loginStatus == "LINKED") {
                            faceScan = false;
                        }
                        workMsg = await this.uploadMpinSuccess(
                            sendRes.data.response.body.access_token,
                            faceScan
                        );
                    } else {
                        if (workMsg != "TO-FACE") {
                            Func.swalAlert("Warning", workMsg, "warning");
                        }
                    }
                } else {
                    if (this.state.comeToMpin) {
                        if (
                            sendRes.status == 500 ||
                            sendRes.status == 503 ||
                            sendRes.status == 503 ||
                            sendRes.status == 403
                        ) {
                            workMsg =
                                "Something went wrong! Please subimit a ticket in our Help Center for further assistance!" +
                                " (SMP)";
                            stayBackHs = true;
                        }
                    }
                    if (workMsg == "") {
                        workMsg = sendRes.message;
                    }
                    Func.swalAlert("Warning", workMsg, "warning");
                }
            } else {
                workMsg = res.data.message + " (DMP)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (DMP)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        } finally {
            if (workMsg != "") {
                if (workMsg != "TO-FACE") {
                    if (!stayStep) {
                        if (stayBackHs) {
                            await this.uploadBackHandShakeOrder();
                            this.setState({ otp: "", mpin: "" });
                            workMsg = "ROCK_BACK";
                        } else {
                            await this.uploadErrorFinishOrder(workMsg, errMemo);
                            await this.loadStepCheck();
                        }
                    }
                    this.resetReactCodeInput("mpin");
                }
            }
        }

        return workMsg;
    };

    //解析MPIN Response
    doMpinResDecode = async (resCode) => {
        let workInfo = {
            status: 200,
            data: {},
            message: "",
        };

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            mpinResCode: resCode,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/do/mpin/decode",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code == 0) {
                let sendInfo64 = window.atob(res.data.data.sendInfo);
                let sendJson = JSON.parse(sendInfo64);
                let deData = sendJson.meta;
                workInfo.data = deData;
            } else {
                workInfo.message = res.data.message + " (DMPRD)";
                Func.swalAlert("Warning", workInfo.message, "warning");
            }
        } catch (err) {
            workInfo.message =
                "Something Error. Please try again later." + " (DMPRD)";
            Func.swalAlert("Error", workInfo.message, "error");
            Func.showLog(err);
        }

        return workInfo;
    };

    uploadMpinSuccess = async (accessToken, faceScan) => {
        let workMsg = "";

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            accessToken: accessToken,
            faceScan: faceScan,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/upload/mpin/success",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code != 0) {
                workMsg = res.data.message + " (UMPS)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (UMPS)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        }

        return workMsg;
    };

    //檢查餘額
    doBalance = async (spTag = "") => {
        let workMsg = "";
        let errMemo = null;

        if (spTag != "") {
            spTag = "(" + spTag + ")";
        }

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/do/balance",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            errMemo = window.btoa(
                JSON.stringify({ request: sendData, response: res.data })
            );
            if (res.data.code == 0) {
                let sendRes = null;
                let reTryCnt = 0;
                while (reTryCnt <= 2) {
                    sendRes = await this.sendToGCashReq(
                        res.data.data.sendInfo,
                        "SBL"
                    );
                    if (
                        sendRes.status == 503 ||
                        sendRes.status == 502 ||
                        sendRes.status == 500 ||
                        sendRes.status == 403
                    ) {
                        reTryCnt++;
                        await Func.sleep(2000);
                    } else {
                        reTryCnt = 3;
                    }
                }
                errMemo = window.btoa(
                    JSON.stringify({
                        request: res.data.data.sendInfo,
                        response: sendRes,
                    })
                );
                if (sendRes.status == 200) {
                    if (sendRes.data.success) {
                        workMsg = await this.uploadBalanceSuccess(
                            sendRes.data.balance
                        );

                        if (workMsg == "") {
                            if (sendRes.data.balance < this.props.data.amount) {
                                workMsg =
                                    "You do not have enough balance. (SBL)" +
                                    spTag;
                                Func.swalAlert("Warning", workMsg, "warning");
                            }
                        }
                    } else {
                        let srMsg = sendRes.data.message;
                        let srCode = sendRes.data.code;
                        let srTraceId = sendRes.data.traceId;
                        workMsg =
                            srMsg +
                            " (" +
                            srCode +
                            "-" +
                            srTraceId +
                            ") (SBL)" +
                            spTag;
                    }
                } else {
                    workMsg = sendRes.message;
                    Func.swalAlert("Warning", workMsg, "warning");
                }
            } else {
                workMsg = res.data.message + " (DBL)" + spTag;
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later. (DBL)" + spTag;
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        } finally {
            if (workMsg != "") {
                await this.uploadErrorFinishOrder(workMsg, errMemo);
                await this.loadStepCheck();
            }
        }

        return workMsg;
    };

    uploadBalanceSuccess = async (balance) => {
        let workMsg = "";

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            balance: balance,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/upload/balance/success",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code != 0) {
                workMsg = res.data.message;

                Func.swalAlert("Warning", workMsg + " (UBLS)", "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (UBLS)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        }

        return workMsg;
    };

    //檢查驗證充值目標
    doLite = async () => {
        let workMsg = "";
        let errMemo = null;

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            targetNumber: this.props.data.detail.phone_number,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/do/lite",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            errMemo = window.btoa(
                JSON.stringify({ request: sendData, response: res.data })
            );
            if (res.data.code == 0) {
                let sendRes = null;
                let reTryCnt = 0;
                while (reTryCnt <= 2) {
                    sendRes = await this.sendToGCashReq(
                        res.data.data.sendInfo,
                        "SLT"
                    );
                    if (
                        sendRes.status == 503 ||
                        sendRes.status == 502 ||
                        sendRes.status == 500 ||
                        sendRes.status == 403
                    ) {
                        reTryCnt++;
                        await Func.sleep(2000);
                    } else {
                        reTryCnt = 3;
                    }
                }
                errMemo = window.btoa(
                    JSON.stringify({
                        request: res.data.data.sendInfo,
                        response: sendRes,
                    })
                );
                if (sendRes.status == 200) {
                    if (sendRes.data.success) {
                        if (sendRes.data.data.kycLevel < 2) {
                            workMsg =
                                "You're about to send money to a non-verified GCash user. (SLT)";
                        }
                    } else {
                        if (sendRes.data.hasOwnProperty("data")) {
                            workMsg = sendRes.data.data.message + " (SLT)";
                        } else {
                            if (sendRes.data.hasOwnProperty("message")) {
                                workMsg = sendRes.data.message + " (SLT)";
                            } else {
                                workMsg =
                                    "Something went wrong, please try again later. (SLT)";
                            }
                        }
                    }
                } else {
                    workMsg = sendRes.message;
                    Func.swalAlert("Warning", workMsg, "warning");
                }
            } else {
                workMsg = res.data.message + " (DLT)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (DLT)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        } finally {
            if (workMsg != "") {
                await this.uploadErrorFinishOrder(workMsg, errMemo);
                await this.loadStepCheck();
            }
        }

        return workMsg;
    };

    uploadLiteSuccess = async () => {
        let workMsg = "";

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/upload/lite/success",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code != 0) {
                workMsg = res.data.message + " (UBLS)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (UBLS)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        }

        return workMsg;
    };

    //讀取Detail
    doDetail = async () => {
        let workMsg = "";
        let errMemo = null;

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/do/detail",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            errMemo = window.btoa(
                JSON.stringify({ request: sendData, response: res.data })
            );
            if (res.data.code == 0) {
                let sendRes = null;
                let reTryCnt = 0;
                while (reTryCnt <= 2) {
                    sendRes = await this.sendToGCashReq(
                        res.data.data.sendInfo,
                        "SDL"
                    );
                    if (
                        sendRes.status == 503 ||
                        sendRes.status == 502 ||
                        sendRes.status == 500 ||
                        sendRes.status == 403
                    ) {
                        reTryCnt++;
                        await Func.sleep(2000);
                    } else {
                        reTryCnt = 3;
                    }
                }
                errMemo = window.btoa(
                    JSON.stringify({
                        request: res.data.data.sendInfo,
                        response: sendRes,
                    })
                );
                if (sendRes.status == 200) {
                    if (sendRes.data.success) {
                        if (sendRes.data.data.kyc_level < 2) {
                            workMsg =
                                "You are a non-verified GCash user, please get verified first. (SDL)";
                        } else {
                            workMsg = await this.uploadDetailSuccess(
                                sendRes.data.data
                            );
                        }
                    } else {
                        let srMsg = sendRes.data.message;
                        let srCode = sendRes.data.code;
                        let srTraceId = sendRes.data.traceId;
                        workMsg = srMsg + " (" + srCode + "-" + srTraceId + ")";
                    }
                } else {
                    workMsg = sendRes.message;
                    Func.swalAlert("Warning", workMsg, "warning");
                }
            } else {
                workMsg = res.data.message + " (DDL)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (DDL)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        } finally {
            if (workMsg != "") {
                await this.uploadErrorFinishOrder(workMsg, errMemo);
                await this.loadStepCheck();
            }
        }

        return workMsg;
    };

    uploadDetailSuccess = async (detail) => {
        let workMsg = "";

        let detailJs = JSON.stringify(detail);
        let detailB64 = window.btoa(detailJs);

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            detail: detailB64,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/upload/detail/success",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code != 0) {
                workMsg = res.data.message + " (UDLS)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (UDLS)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        }

        return workMsg;
    };

    //執行Login Relink
    doRelink = async () => {
        let workMsg = "";
        let errMemo = null;

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/do/relink",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            errMemo = window.btoa(
                JSON.stringify({ request: sendData, response: res.data })
            );
            if (res.data.code == 0) {
                let sendRes = null;
                let reTryCnt = 0;
                while (reTryCnt <= 2) {
                    sendRes = await this.sendToGCashReq(
                        res.data.data.sendInfo,
                        "SRLK"
                    );
                    if (
                        sendRes.status == 503 ||
                        sendRes.status == 502 ||
                        sendRes.status == 500 ||
                        sendRes.status == 403
                    ) {
                        reTryCnt++;
                        await Func.sleep(2000);
                    } else {
                        reTryCnt = 3;
                    }
                }
                errMemo = window.btoa(
                    JSON.stringify({
                        request: res.data.data.sendInfo,
                        response: sendRes,
                    })
                );
                if (sendRes.status == 200) {
                    if (sendRes.data.hasOwnProperty("response")) {
                        if (sendRes.data.response.body.status != "LINKED") {
                            let srBody = sendRes.data.response.body;
                            if (srBody.hasOwnProperty("securityId")) {
                                if (srBody.securityId != "") {
                                    this.setState({ loginReqInfo: srBody });
                                } else {
                                    workMsg =
                                        "Failed to get user information, please try again later! (SRLK)";
                                }
                            } else {
                                workMsg =
                                    "Failed to get user information, please try again later. (SRLK)";
                            }
                        } else {
                            this.setState({ loginStatus: "LINKED" });
                            workMsg = await this.uploadNotifyFaceScanSuccess(
                                false
                            );
                        }
                    } else {
                        workMsg =
                            "Something went wrong, please try again later." +
                            " (SRLK)";
                        Func.swalAlert("Warning", workMsg, "warning");
                    }
                } else {
                    workMsg = sendRes.message;
                    Func.swalAlert("Warning", workMsg, "warning");
                }
            } else {
                workMsg = res.data.message + " (DRLK)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (DRLK)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        } finally {
            if (workMsg != "") {
                await this.uploadErrorFinishOrder(workMsg, errMemo);
                await this.loadStepCheck();
            }
        }

        return workMsg;
    };

    uploadRelinkSuccess = async (detail) => {
        let workMsg = "";

        let detailJs = JSON.stringify(detail);
        let detailB64 = window.btoa(detailJs);

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            detail: detailB64,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/upload/detail/success",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code != 0) {
                workMsg = res.data.message + " (URLS)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (UDLS)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        }

        return workMsg;
    };

    //執行Login Relink Verify
    doRelinkVerify = async () => {
        let workMsg = "";
        let errMemo = null;

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            eid: this.state.loginReqInfo.eventLinkId,
            sid: this.state.loginReqInfo.securityId,
            mpin: this.state.mpin,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/do/relink/verify",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            errMemo = window.btoa(
                JSON.stringify({ request: sendData, response: res.data })
            );
            if (res.data.code == 0) {
                let sendRes = null;
                let reTryCnt = 0;
                while (reTryCnt <= 2) {
                    sendRes = await this.sendToGCashReq(
                        res.data.data.sendInfo,
                        "SRLKV"
                    );
                    if (
                        sendRes.status == 503 ||
                        sendRes.status == 502 ||
                        sendRes.status == 500 ||
                        sendRes.status == 403
                    ) {
                        reTryCnt++;
                        await Func.sleep(2000);
                    } else {
                        reTryCnt = 3;
                    }
                }
                errMemo = window.btoa(
                    JSON.stringify({
                        request: res.data.data.sendInfo,
                        response: sendRes,
                    })
                );
                if (sendRes.status == 200) {
                    if (sendRes.data.hasOwnProperty("response")) {
                        let srRes = sendRes.data.response;
                        if (srRes.hasOwnProperty("body")) {
                            let srResBody = sendRes.data.response.body;
                            if (srResBody.hasOwnProperty("access_token")) {
                                workMsg = await this.uploadReLinkVerifySuccess(
                                    sendRes.data.response.body.access_token,
                                    true
                                );
                            } else {
                                // workMsg =
                                //     "Something went wrong, please try again later." +
                                //     " (SRLKV)(NAT)";
                                // Func.swalAlert("Warning", workMsg, "warning");
                                // 取得狀態碼
                                let srCode = "";
                                if (srBody.hasOwnProperty("result_code")) {
                                    srCode = srBody.result_code;
                                } else if (srBody.hasOwnProperty("code")) {
                                    srCode = srBody.code;
                                }
                                switch (srCode) {
                                    case "GE15199993302022":
                                        workMsg =
                                            "Incorrect MPIN. Enter your correct MPIN to avoid being locked out. (SRLKV)";
                                        break;
                                    case "GE15199993302025":
                                        workMsg =
                                            "Please reset your MPIN to access your account again. (SRLKV)";
                                        break;
                                    case "GE15199993302011":
                                        workMsg =
                                            "You're not GCash user. (SRLKV)";
                                        break;
                                    default:
                                        let srCodeStr = "(" + srCode + ")";
                                        workMsg =
                                            "Something went wrong. Please subimit a ticket in our Help Center for further assistance. " +
                                            srCodeStr +
                                            "(SRLKV)";
                                        break;
                                }
                            }
                        } else {
                            workMsg =
                                "Something went wrong, please try again later." +
                                " (SRLKV)(NB)";
                            Func.swalAlert("Warning", workMsg, "warning");
                        }
                    } else {
                        workMsg =
                            "Something went wrong, please try again later." +
                            " (SRLKV)";
                        Func.swalAlert("Warning", workMsg, "warning");
                    }
                } else {
                    workMsg = sendRes.message;
                    Func.swalAlert("Warning", workMsg, "warning");
                }
            } else {
                workMsg = res.data.message + " (SRLKV)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (DRLKV)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        } finally {
            if (workMsg != "") {
                await this.uploadErrorFinishOrder(workMsg, errMemo);
                await this.loadStepCheck();
            }
        }

        return workMsg;
    };

    uploadReLinkVerifySuccess = async (accessToken, faceScan) => {
        let workMsg = "";

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            accessToken: accessToken,
            faceScan: faceScan,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/upload/mpin/success",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code != 0) {
                workMsg = res.data.message + " (URLVS)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (URLVS)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        }

        return workMsg;
    };

    //發送Enter Send
    doEnterSend = async () => {
        let workMsg = "";
        let errMemo = null;

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/do/express/money",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            errMemo = window.btoa(
                JSON.stringify({ request: sendData, response: res.data })
            );
            if (res.data.code == 0) {
                let sendRes = await this.sendToGCashReq(
                    res.data.data.sendInfo,
                    "SEM"
                );
                // let sendRes = null;
                // let reTryCnt = 0;
                // while (reTryCnt <= 1) {
                //     sendRes = await this.sendToGCashReq(
                //         res.data.data.sendInfo,
                //         "SEM"
                //     );
                //     if (sendRes.status == 403) {
                //         reTryCnt++;
                //         await Func.sleep(2000);
                //     } else {
                //         reTryCnt = 3;
                //     }
                // }
                errMemo = window.btoa(
                    JSON.stringify({
                        request: res.data.data.sendInfo,
                        response: sendRes,
                    })
                );
                if (sendRes.status == 200) {
                    let srResult = sendRes.data.response.body.result;
                    let srSuccess = sendRes.data.response.body.success;
                    let srBody = sendRes.data.response.body;

                    if (srSuccess) {
                        if (
                            srResult == 200 &&
                            srBody.hasOwnProperty("riskChallengeView")
                        ) {
                            let riskResult =
                                sendRes.data.response.body.riskChallengeView
                                    .riskResult;
                            let eventLinkId =
                                sendRes.data.response.body.riskChallengeView
                                    .eventLinkId;
                            let securityId =
                                sendRes.data.response.body.riskChallengeView
                                    .securityId;
                            let transId = sendRes.data.response.body.transId;

                            workMsg = await this.uploadEnterSendSuccess(
                                riskResult,
                                eventLinkId,
                                securityId,
                                transId,
                                true
                            );
                            if (workMsg == "") {
                                if (riskResult == "VERIFICATION") {
                                    this.doRequestSendOtp();
                                } else if (riskResult == "REJECT") {
                                    workMsg =
                                        "Sorry, we're unable to process your request. For your protection, we need to take another look at your transaction. You will temporarily be unable to use Send Money at the moment. (SEM)";
                                }
                            }
                        } else {
                            workMsg =
                                "Something went wrong!!! Please try again later. (SEM)";
                            Func.swalAlert("Warning", workMsg, "warning");
                        }
                    } else {
                        workMsg = sendRes.data.response.body.message + " (SEM)";
                        Func.swalAlert("Warning", workMsg, "warning");
                    }
                } else {
                    workMsg = sendRes.message;
                    Func.swalAlert("Warning", workMsg, "warning");
                }
            } else {
                workMsg = res.data.message + " (SEM)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (SEM)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        } finally {
            if (workMsg != "") {
                await this.uploadErrorFinishOrder(workMsg, errMemo);
                await this.loadStepCheck();
            }
        }

        return workMsg;
    };

    uploadEnterSendSuccess = async (
        riskResult,
        eventLinkId,
        securityId,
        transId,
        isFirst
    ) => {
        let workMsg = "";

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            riskResult: riskResult,
            eventLinkId: eventLinkId,
            securityId: securityId,
            transId: transId,
            isFirst: isFirst,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/upload/express/money/success",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code != 0) {
                workMsg = res.data.message + " (UEMS)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (UEMS)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        }

        return workMsg;
    };

    //請求交易OTP
    doRequestSendOtp = async () => {
        let workMsg = "";
        let errMemo = null;

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/do/request/send/otp",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            errMemo = window.btoa(
                JSON.stringify({ request: sendData, response: res.data })
            );
            if (res.data.code == 0) {
                this.setState({ rsoResUrl: "" });
                let chkCrso = true;
                let cntCrso = 0;
                let dataId = res.data.data.id;
                while (this.state.rsoResUrl == "" && chkCrso) {
                    await Func.sleep(1500);
                    cntCrso++;
                    if (cntCrso >= 11) {
                        workMsg = "Request count exceeded. (DRSO)";
                        chkCrso = false;
                    } else {
                        workMsg = await this.confirmRequestSendOtp(dataId);
                        if (workMsg != "") {
                            chkCrso = false;
                        }
                    }
                }
                if (workMsg == "") {
                    let setHeaderB64 = window.atob(res.data.data.header);
                    let setHeaderJson = JSON.parse(setHeaderB64);
                    let setProxyJson = null;
                    if (res.data.data.proxy != null) {
                        let setProxyB64 = window.atob(res.data.data.proxy);
                        setProxyJson = JSON.parse(setProxyB64);
                    }
                    let sendRes = await this.sendToGCashReqGet(
                        this.state.rsoResUrl,
                        setHeaderJson,
                        "SRSO",
                        setProxyJson
                    );
                    errMemo = window.btoa(
                        JSON.stringify({
                            request: res.data.data,
                            response: sendRes,
                        })
                    );
                    if (sendRes.status == 200) {
                        if (
                            sendRes.data.resultStatus == 1000 &&
                            sendRes.data.result.success &&
                            sendRes.data.result.verifyCode == "SUCCESS" &&
                            sendRes.data.result.nextStep == "otpSms"
                        ) {
                            workMsg = "";
                            this.setState({ sendOtpCount: 0 });
                        } else {
                            workMsg =
                                sendRes.data.result.verifyMessage + " (SRSO)";
                            Func.swalAlert("Warning", workMsg, "warning");
                        }
                    } else {
                        workMsg = sendRes.message;
                        Func.swalAlert("Warning", workMsg, "warning");
                    }
                }
            } else {
                workMsg = res.data.message + " (DRSO)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (DRSO)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        } finally {
            if (workMsg != "") {
                await this.uploadErrorFinishOrder(workMsg, errMemo);
                await this.loadStepCheck();
            }
        }

        return workMsg;
    };

    confirmRequestSendOtp = async (reqId) => {
        let workMsg = "";

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            reqId: reqId,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/confirm/request/send/otp",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code == 0) {
                this.setState({ rsoResUrl: res.data.data.response });
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (CRSO)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        }

        return workMsg;
    };

    //驗證交易OTP
    doVerifySendOtp = async () => {
        let workMsg = "";
        let errMemo = null;

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            sendOtp: this.state.sendOtp,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/do/verify/send/otp",
            sendData,
            "POST",
            true
        );
        let stayStep = false;
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            errMemo = window.btoa(
                JSON.stringify({ request: sendData, response: res.data })
            );
            if (res.data.code == 0) {
                this.setState({ vsoResUrl: "" });
                let chkCvso = true;
                let cntCvso = 0;
                let dataId = res.data.data.id;
                while (this.state.vsoResUrl == "" && chkCvso) {
                    await Func.sleep(1500);
                    cntCvso++;
                    if (cntCvso >= 11) {
                        workMsg = "Request count exceeded. (DVSO)";
                        chkCvso = false;
                    } else {
                        workMsg = await this.confirmVerifySendOtp(dataId);
                        if (workMsg != "") {
                            chkCvso = false;
                        }
                    }
                }
                if (workMsg == "") {
                    let setHeaderB64 = window.atob(res.data.data.header);
                    let setHeaderJson = JSON.parse(setHeaderB64);
                    let setProxyJson = null;
                    if (res.data.data.proxy != null) {
                        let setProxyB64 = window.atob(res.data.data.proxy);
                        setProxyJson = JSON.parse(setProxyB64);
                    }
                    let sendRes = await this.sendToGCashReqGet(
                        this.state.vsoResUrl,
                        setHeaderJson,
                        "SVSO",
                        setProxyJson
                    );
                    errMemo = window.btoa(
                        JSON.stringify({
                            request: res.data.data,
                            response: sendRes,
                        })
                    );
                    if (sendRes.status == 200) {
                        if (
                            sendRes.data.resultStatus == 1000 &&
                            sendRes.data.result.finish &&
                            sendRes.data.result.success &&
                            sendRes.data.result.verifyCode == "SUCCESS" &&
                            sendRes.data.result.verifyMessage == "SUCCESS" &&
                            sendRes.data.result.verifySuccess
                        ) {
                            workMsg = "";
                        } else {
                            workMsg = sendRes.data.result.verifyMessage;
                            Func.swalAlert("Warning", workMsg, "warning");
                            let sendOtpCount = parseInt(
                                this.state.sendOtpCount
                            );
                            if (sendOtpCount < 2) {
                                this.setState({
                                    sendOtp: "",
                                    sendOtpCount: sendOtpCount + 1,
                                    vsoResUrl: "",
                                });
                                stayStep = true;
                            }
                        }
                    } else {
                        workMsg = sendRes.message;
                        Func.swalAlert("Warning", workMsg, "warning");
                    }
                }
            } else {
                workMsg = res.data.message + " (DVSO)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (DVSO)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        } finally {
            if (workMsg != "") {
                if (!stayStep) {
                    await this.uploadErrorFinishOrder(workMsg, errMemo);
                    await this.loadStepCheck();
                }
                this.resetReactCodeInput("sendOtp");
            }
        }

        return workMsg;
    };

    confirmVerifySendOtp = async (reqId) => {
        let workMsg = "";

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            reqId: reqId,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/confirm/verify/send/otp",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code == 0) {
                this.setState({ vsoResUrl: res.data.data.response });
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (CVSO)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        }

        return workMsg;
    };

    //請求 Face OTP
    doRequestFaceOtp = async () => {
        let workMsg = "";
        let errMemo = null;

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            sid: this.state.loginReqInfo.securityId,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/do/request/face/otp",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            errMemo = window.btoa(
                JSON.stringify({ request: sendData, response: res.data })
            );
            if (res.data.code == 0) {
                this.setState({ rfoResUrl: "" });
                let chkCrfo = true;
                let cntCrfo = 0;
                let dataId = res.data.data.id;
                while (this.state.rfoResUrl == "" && chkCrfo) {
                    await Func.sleep(1500);
                    cntCrfo++;
                    if (cntCrfo >= 11) {
                        workMsg = "Request count exceeded. (DRFO)";
                        chkCrfo = false;
                    } else {
                        workMsg = await this.confirmRequestFaceOtp(dataId);
                        if (workMsg != "") {
                            chkCrfo = false;
                        }
                    }
                }
                if (workMsg == "") {
                    let setHeaderB64 = window.atob(res.data.data.header);
                    let setHeaderJson = JSON.parse(setHeaderB64);
                    let setProxyJson = null;
                    if (res.data.data.proxy != null) {
                        let setProxyB64 = window.atob(res.data.data.proxy);
                        setProxyJson = JSON.parse(setProxyB64);
                    }
                    let sendRes = await this.sendToGCashReqGet(
                        this.state.rfoResUrl,
                        setHeaderJson,
                        "SRFO",
                        setProxyJson
                    );
                    errMemo = window.btoa(
                        JSON.stringify({
                            request: res.data.data,
                            response: sendRes,
                        })
                    );
                    if (sendRes.status == 200) {
                        if (
                            sendRes.data.resultStatus == 1000 &&
                            sendRes.data.result.success &&
                            sendRes.data.result.verifyCode == "SUCCESS" &&
                            sendRes.data.result.nextStep == "otpSms"
                        ) {
                            workMsg = "";
                            this.setState({ sendOtpCount: 0 });
                        } else {
                            workMsg =
                                sendRes.data.result.verifyMessage + " (SRFO)";
                            Func.swalAlert("Warning", workMsg, "warning");
                        }
                    } else {
                        workMsg = sendRes.message;
                        Func.swalAlert("Warning", workMsg, "warning");
                    }
                }
            } else {
                workMsg = res.data.message + " (DRFO)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (DRFO)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        } finally {
            if (workMsg != "") {
                await this.uploadErrorFinishOrder(workMsg, errMemo);
                await this.loadStepCheck();
            }
        }

        return workMsg;
    };

    confirmRequestFaceOtp = async (reqId) => {
        let workMsg = "";

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            reqId: reqId,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/confirm/request/face/otp",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code == 0) {
                this.setState({ rfoResUrl: res.data.data.response });
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (CRFO)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        }

        return workMsg;
    };

    //取得Face Scan
    doGetFaceScan = async () => {
        let workMsg = "";
        let errMemo = null;

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            verifyId: this.state.loginReqInfo.securityId,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/do/face/scan/get",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            errMemo = window.btoa(
                JSON.stringify({ request: sendData, response: res.data })
            );
            if (res.data.code == 0) {
                this.setState({ gfsResUrl: "" });
                let chkCrso = true;
                let cntCrso = 0;
                let dataId = res.data.data.id;
                while (this.state.gfsResUrl == "" && chkCrso) {
                    await Func.sleep(1500);
                    cntCrso++;
                    if (cntCrso >= 11) {
                        workMsg = "Request count exceeded. (DGFS)";
                        chkCrso = false;
                    } else {
                        workMsg = await this.confirmGetFaceScan(dataId);
                        if (workMsg != "") {
                            chkCrso = false;
                        }
                    }
                }
                if (workMsg == "") {
                    let setHeaderB64 = window.atob(res.data.data.header);
                    let setHeaderJson = JSON.parse(setHeaderB64);
                    let setProxyJson = null;
                    if (res.data.data.proxy != null) {
                        let setProxyB64 = window.atob(res.data.data.proxy);
                        setProxyJson = JSON.parse(setProxyB64);
                    }
                    let sendRes = await this.sendToGCashReqGet(
                        this.state.gfsResUrl,
                        setHeaderJson,
                        "SGFS",
                        setProxyJson
                    );
                    errMemo = window.btoa(
                        JSON.stringify({
                            request: res.data.data,
                            response: sendRes,
                        })
                    );
                    if (sendRes.status == 200) {
                        if (
                            sendRes.data.resultStatus == 1000 &&
                            sendRes.data.result.success &&
                            sendRes.data.result.verifyCode == "SUCCESS"
                        ) {
                            if (sendRes.data.result.nextStep == "ZOLOZ_FACE") {
                                // workMsg = "GFS-GFOFA";

                                let resultJd = JSON.parse(
                                    sendRes.data.result.data
                                );
                                let resultJds = JSON.parse(resultJd.clientCfg);

                                this.setState({
                                    loginFaceTransactionId:
                                        resultJd.transactionId,
                                    loginFaceFaceZimId: resultJds.faceZimId,
                                    loginFaceMerchantId: resultJds.merchantId,
                                    loginFaceZimInitResp: resultJds.zimInitResp,
                                    clientCfg: window.btoa(resultJd.clientCfg),
                                });

                                await this.uploadNotifyFaceScanSuccess(
                                    false,
                                    true,
                                    window.btoa(resultJd.clientCfg)
                                );
                            } else if (
                                sendRes.data.result.nextStep == "otpSms"
                            ) {
                                await this.uploadNotifyFaceScanSuccess(
                                    true,
                                    false
                                );
                                // workMsg = "GFS-GFOTP";
                                // workMsg =
                                //     "You are a non-verified GCash user, please get verified first. (SGFS)";
                            } else {
                                let gfsNs = sendRes.data.result.nextStep;
                                workMsg =
                                    sendRes.data.result.verifyMessage +
                                    " (SGFS)(" +
                                    gfsNs +
                                    ")";
                                Func.swalAlert("Warning", workMsg, "warning");
                            }
                        } else {
                            workMsg =
                                sendRes.data.result.verifyMessage + " (SGFS)";
                            Func.swalAlert("Warning", workMsg, "warning");
                        }
                    } else {
                        workMsg = sendRes.message;
                        Func.swalAlert("Warning", workMsg, "warning");
                    }
                }
            } else {
                workMsg = res.data.message + " (DGFS)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (DGFS)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        } finally {
            if (workMsg != "") {
                // if (workMsg != "GFS-GFOTP") {
                //     await this.uploadErrorFinishOrder(workMsg, errMemo);
                //     await this.loadStepCheck();
                // }
                await this.uploadErrorFinishOrder(workMsg, errMemo);
                await this.loadStepCheck();
            }
        }

        return workMsg;
    };

    confirmGetFaceScan = async (reqId) => {
        let workMsg = "";

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            reqId: reqId,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/confirm/face/scan/get",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code == 0) {
                this.setState({ gfsResUrl: res.data.data.response });
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (CGFS)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        }

        return workMsg;
    };

    //請求Face Scan
    doRequestFaceScan = async () => {
        let workMsg = "";
        let errMemo = null;

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            verifyId: this.state.loginReqInfo.securityId,
            transactionId: this.state.loginFaceTransactionId,
            faceZimId: this.state.loginFaceFaceZimId,
            merchantId: this.state.loginFaceMerchantId,
            zimInitResp: this.state.loginFaceZimInitResp,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/do/face/scan/request",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            errMemo = window.btoa(
                JSON.stringify({ request: sendData, response: res.data })
            );
            if (res.data.code == 0) {
                this.setState({ rsoResUrl: "" });
                let chkCrso = true;
                let cntCrso = 0;
                let dataId = res.data.data.id;
                while (this.state.rsoResUrl == "" && chkCrso) {
                    await Func.sleep(1500);
                    cntCrso++;
                    if (cntCrso >= 11) {
                        workMsg = "Request count exceeded. (DRFS)";
                        chkCrso = false;
                    } else {
                        workMsg = await this.confirmRequestFaceScan(dataId);
                        if (workMsg != "") {
                            chkCrso = false;
                        }
                    }
                }
                if (workMsg == "") {
                    let setHeaderB64 = window.atob(res.data.data.header);
                    let setHeaderJson = JSON.parse(setHeaderB64);
                    let setProxyJson = null;
                    if (res.data.data.proxy != null) {
                        let setProxyB64 = window.atob(res.data.data.proxy);
                        setProxyJson = JSON.parse(setProxyB64);
                    }
                    let sendRes = await this.sendToGCashReqGet(
                        this.state.rsoResUrl,
                        setHeaderJson,
                        "SRFS",
                        setProxyJson
                    );
                    errMemo = window.btoa(
                        JSON.stringify({
                            request: res.data.data,
                            response: sendRes,
                        })
                    );
                    if (sendRes.status == 200) {
                        if (
                            sendRes.data.resultStatus == 1000 &&
                            sendRes.data.result.success &&
                            sendRes.data.result.verifyCode == "SUCCESS"
                        ) {
                            workMsg = "";
                        } else {
                            workMsg = sendRes.data.result.verifyMessage;
                            Func.swalAlert("Warning", workMsg, "warning");
                        }
                    } else {
                        workMsg = sendRes.message;
                        Func.swalAlert("Warning", workMsg, "warning");
                    }
                }
            } else {
                workMsg = res.data.message + " (DRFS)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (DRFS)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        } finally {
            if (workMsg != "") {
                await this.uploadErrorFinishOrder(workMsg, errMemo);
                await this.loadStepCheck();
            }
        }

        return workMsg;
    };

    confirmRequestFaceScan = async (reqId) => {
        let workMsg = "";

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            reqId: reqId,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/confirm/face/scan/request",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code == 0) {
                this.setState({ rsoResUrl: res.data.data.response });
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (CGFS)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        }

        return workMsg;
    };

    //通知Face Scan
    doNotifyFaceScan = async () => {
        let workMsg = "";
        let errMemo = null;

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            verifyId: this.state.loginReqInfo.securityId,
            transactionId: this.state.loginFaceTransactionId,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/do/face/scan/notify",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            errMemo = window.btoa(
                JSON.stringify({ request: sendData, response: res.data })
            );
            if (res.data.code == 0) {
                this.setState({ nfsResUrl: "" });
                let chkCrso = true;
                let cntCrso = 0;
                let dataId = res.data.data.id;
                while (this.state.nfsResUrl == "" && chkCrso) {
                    await Func.sleep(1500);
                    cntCrso++;
                    if (cntCrso >= 11) {
                        workMsg = "Request count exceeded. (DNFS)";
                        chkCrso = false;
                    } else {
                        workMsg = await this.confirmNotifyFaceScan(dataId);
                        if (workMsg != "") {
                            chkCrso = false;
                        }
                    }
                }
                if (workMsg == "") {
                    let setHeaderB64 = window.atob(res.data.data.header);
                    let setHeaderJson = JSON.parse(setHeaderB64);
                    let setProxyJson = null;
                    if (res.data.data.proxy != null) {
                        let setProxyB64 = window.atob(res.data.data.proxy);
                        setProxyJson = JSON.parse(setProxyB64);
                    }
                    let sendRes = await this.sendToGCashReqGet(
                        this.state.nfsResUrl,
                        setHeaderJson,
                        "SNFS",
                        setProxyJson
                    );
                    errMemo = window.btoa(
                        JSON.stringify({
                            request: res.data.data,
                            response: sendRes,
                        })
                    );
                    if (sendRes.status == 200) {
                        // workMsg = await this.uploadNotifyFaceScanSuccess(false);
                        // workMsg = "Do-LINK";
                        if (
                            sendRes.data.resultStatus == 1000 &&
                            sendRes.data.result.success &&
                            sendRes.data.result.verifyCode == "SUCCESS"
                        ) {
                            // workMsg = await this.uploadNotifyFaceScanSuccess(
                            //     false
                            // );
                            // if (workMsg == "") {
                            //     workMsg = "Do-LINK";
                            // }
                            if (sendRes.data.result.nextStep == "otpSms") {
                                workMsg = "Do-LINK";
                                await this.uploadNotifyFaceScanSuccess(
                                    true,
                                    false
                                );
                            } else {
                                workMsg = await this.uploadVerifyFaceOtpSuccess(
                                    false,
                                    true
                                );
                            }
                        } else if (
                            sendRes.data.result.finishCode == "2006" &&
                            sendRes.data.result.verifyCode == "CLOSED"
                        ) {
                            workMsg = sendRes.data.result.verifyMessage;
                            Func.swalAlert("Warning", workMsg, "warning");
                        } else {
                            // workMsg = sendRes.data.result.verifyMessage;
                            // Func.swalAlert("Warning", workMsg, "warning");
                            // workMsg = await this.uploadNotifyFaceScanSuccess(
                            //     true
                            // );
                            workMsg = await this.uploadVerifyFaceOtpSuccess(
                                false,
                                false
                            );
                        }
                    } else {
                        workMsg = sendRes.message;
                        Func.swalAlert("Warning", workMsg, "warning");
                    }
                }
            } else {
                workMsg = res.data.message + " (DNFS)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (DNFS)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        } finally {
            if (workMsg != "") {
                if (workMsg != "Do-LINK") {
                    await this.uploadErrorFinishOrder(workMsg, errMemo);
                    await this.loadStepCheck();
                }
            }
        }

        return workMsg;
    };

    confirmNotifyFaceScan = async (reqId) => {
        let workMsg = "";

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            reqId: reqId,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/confirm/face/scan/notify",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code == 0) {
                this.setState({ nfsResUrl: res.data.data.response });
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (CGFS)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        }

        return workMsg;
    };

    uploadNotifyFaceScanSuccess = async (
        hasFaceOtp,
        hasFaceScan,
        clientCfg = ""
    ) => {
        let workMsg = "";

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            hasFaceOtp: hasFaceOtp,
            hasFaceScan: hasFaceScan,
        };
        if (clientCfg != "") {
            sendData.clientCfg = clientCfg;
        }
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/upload/face/scan/notify/success",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code != 0) {
                workMsg = res.data.message + " (UNFSS)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (UNFSS)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        }

        return workMsg;
    };

    //驗證Face OTP
    doVerifyFaceOtp = async () => {
        let workMsg = "";
        let errMemo = null;

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            sendOtp: this.state.faceOtp,
            sid: this.state.loginReqInfo.securityId,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/do/verify/face/otp",
            sendData,
            "POST",
            true
        );
        let stayStep = false;
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            errMemo = window.btoa(
                JSON.stringify({ request: sendData, response: res.data })
            );
            if (res.data.code == 0) {
                this.setState({ vfoResUrl: "" });
                let chkCvso = true;
                let cntCvso = 0;
                let dataId = res.data.data.id;
                while (this.state.vfoResUrl == "" && chkCvso) {
                    await Func.sleep(1500);
                    cntCvso++;
                    if (cntCvso >= 11) {
                        workMsg = "Request count exceeded. (DVFO)";
                        chkCvso = false;
                    } else {
                        workMsg = await this.confirmVerifyFaceOtp(dataId);
                        if (workMsg != "") {
                            chkCvso = false;
                        }
                    }
                }
                if (workMsg == "") {
                    let setHeaderB64 = window.atob(res.data.data.header);
                    let setHeaderJson = JSON.parse(setHeaderB64);
                    let setProxyJson = null;
                    if (res.data.data.proxy != null) {
                        let setProxyB64 = window.atob(res.data.data.proxy);
                        setProxyJson = JSON.parse(setProxyB64);
                    }
                    let sendRes = await this.sendToGCashReqGet(
                        this.state.vfoResUrl,
                        setHeaderJson,
                        "SVFO",
                        setProxyJson
                    );
                    errMemo = window.btoa(
                        JSON.stringify({
                            request: res.data.data,
                            response: sendRes,
                        })
                    );
                    if (sendRes.status == 200) {
                        if (
                            sendRes.data.resultStatus == 1000 &&
                            sendRes.data.result.finish &&
                            sendRes.data.result.success &&
                            sendRes.data.result.verifyCode == "SUCCESS" &&
                            sendRes.data.result.verifyMessage == "SUCCESS" &&
                            sendRes.data.result.verifySuccess
                        ) {
                            workMsg = await this.uploadVerifyFaceOtpSuccess(
                                true,
                                false
                            );
                        } else {
                            workMsg = sendRes.data.result.verifyMessage;
                            Func.swalAlert("Warning", workMsg, "warning");
                            let faceOtpCount = parseInt(
                                this.state.faceOtpCount
                            );
                            if (faceOtpCount < 2) {
                                this.setState({
                                    faceOtp: "",
                                    faceOtpCount: faceOtpCount + 1,
                                    vfoResUrl: "",
                                });
                                stayStep = true;
                            }
                            await this.uploadVerifyFaceOtpSuccess(false, false);
                        }
                    } else {
                        workMsg = sendRes.message;
                        Func.swalAlert("Warning", workMsg, "warning");
                    }
                }
            } else {
                workMsg = res.data.message + " (DVFO)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (DVFO)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        } finally {
            if (workMsg != "") {
                if (!stayStep) {
                    await this.uploadErrorFinishOrder(workMsg, errMemo);
                    await this.loadStepCheck();
                }
                this.resetReactCodeInput("faceOtp");
            }
        }

        return workMsg;
    };

    confirmVerifyFaceOtp = async (reqId) => {
        let workMsg = "";

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            reqId: reqId,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/confirm/verify/face/otp",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code == 0) {
                this.setState({ vfoResUrl: res.data.data.response });
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (CVFO)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        }

        return workMsg;
    };

    uploadVerifyFaceOtpSuccess = async (resultFaceOtp, resultFaceScan) => {
        let workMsg = "";

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            resultFaceOtp: resultFaceOtp,
            resultFaceScan: resultFaceScan,
        };
        if (resultFaceOtp || resultFaceScan) {
            sendData.securityId = this.state.loginReqInfo.securityId;
            sendData.eventLinkId = this.state.loginReqInfo.eventLinkId;
            sendData.transactionId = this.state.loginFaceTransactionId;
        }
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/upload/verify/face/otp/success",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code != 0) {
                workMsg = res.data.message + " (UVFOS)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (UVFOS)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        }

        return workMsg;
    };

    //發送Enter Send After Verify Send Otp
    doEnterSendSecurity = async () => {
        let workMsg = "";
        let errMemo = null;

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/do/express/money/security",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            errMemo = window.btoa(
                JSON.stringify({ request: sendData, response: res.data })
            );
            if (res.data.code == 0) {
                let sendRes = await this.sendToGCashReq(
                    res.data.data.sendInfo,
                    "SEMS"
                );
                // let sendRes = null;
                // let reTryCnt = 0;
                // while (reTryCnt <= 1) {
                //     sendRes = await this.sendToGCashReq(
                //         res.data.data.sendInfo,
                //         "SEMS"
                //     );
                //     if (sendRes.status == 403) {
                //         reTryCnt++;
                //         await Func.sleep(2000);
                //     } else {
                //         reTryCnt = 3;
                //     }
                // }
                errMemo = window.btoa(
                    JSON.stringify({
                        request: res.data.data.sendInfo,
                        response: sendRes,
                    })
                );
                if (sendRes.status == 200) {
                    let srResult = sendRes.data.response.body.result;
                    let srSuccess = sendRes.data.response.body.success;
                    let srBody = sendRes.data.response.body;

                    if (srSuccess) {
                        if (
                            srResult == 200 &&
                            srBody.hasOwnProperty("riskChallengeView")
                        ) {
                            let riskResult =
                                sendRes.data.response.body.riskChallengeView
                                    .riskResult;
                            let eventLinkId =
                                sendRes.data.response.body.riskChallengeView
                                    .eventLinkId;
                            let securityId =
                                sendRes.data.response.body.riskChallengeView
                                    .securityId;
                            let transId = sendRes.data.response.body.transId;

                            workMsg = await this.uploadEnterSendSuccess(
                                riskResult,
                                eventLinkId,
                                securityId,
                                transId,
                                false
                            );
                            if (workMsg) {
                                if (riskResult == "REJECT") {
                                    workMsg =
                                        "Sorry, we're unable to process your request. For your protection, we need to take another look at your transaction. You will temporarily be unable to use Send Money at the moment. (SEM)";
                                }
                            }
                        } else {
                            workMsg =
                                "Something went wrong!!! Please try again later. (SEMS)";
                            Func.swalAlert("Warning", workMsg, "warning");
                        }
                    } else {
                        workMsg =
                            sendRes.data.response.body.message + " (SEMS)";
                        Func.swalAlert("Warning", workMsg, "warning");
                    }
                } else {
                    workMsg = sendRes.message;
                    Func.swalAlert("Warning", workMsg, "warning");
                }
            } else {
                workMsg = res.data.message + " (DEMS)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (DEMS)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        } finally {
            if (workMsg != "") {
                await this.uploadErrorFinishOrder(workMsg, errMemo);
                await this.loadStepCheck();
            }
        }

        return workMsg;
    };

    //發送Enter Send After Verify Send Face
    doEnterSendFaceSecurity = async () => {
        let workMsg = "";
        let errMemo = null;

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/do/express/money/face/security",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            errMemo = window.btoa(
                JSON.stringify({ request: sendData, response: res.data })
            );
            if (res.data.code == 0) {
                let sendRes = await this.sendToGCashReq(
                    res.data.data.sendInfo,
                    "SEMFS"
                );
                errMemo = window.btoa(
                    JSON.stringify({
                        request: res.data.data.sendInfo,
                        response: sendRes,
                    })
                );
                if (sendRes.status == 200) {
                    let srResult = sendRes.data.response.body.result;
                    let srSuccess = sendRes.data.response.body.success;
                    let srBody = sendRes.data.response.body;

                    if (srSuccess) {
                        if (
                            srResult == 200 &&
                            srBody.hasOwnProperty("riskChallengeView")
                        ) {
                            let riskResult =
                                sendRes.data.response.body.riskChallengeView
                                    .riskResult;
                            let eventLinkId =
                                sendRes.data.response.body.riskChallengeView
                                    .eventLinkId;
                            let securityId =
                                sendRes.data.response.body.riskChallengeView
                                    .securityId;
                            let transId = sendRes.data.response.body.transId;

                            workMsg = await this.uploadEnterSendSuccess(
                                riskResult,
                                eventLinkId,
                                securityId,
                                transId,
                                false
                            );
                            if (workMsg) {
                                if (riskResult == "REJECT") {
                                    workMsg =
                                        "Sorry, we're unable to process your request. For your protection, we need to take another look at your transaction. You will temporarily be unable to use Send Money at the moment. (SEM)";
                                }
                            }
                        } else {
                            workMsg =
                                "Something went wrong!!! Please try again later. (SEMFS)";
                            Func.swalAlert("Warning", workMsg, "warning");
                        }
                    } else {
                        workMsg =
                            sendRes.data.response.body.message + " (SEMFS)";
                        Func.swalAlert("Warning", workMsg, "warning");
                    }
                } else {
                    workMsg = sendRes.message;
                    Func.swalAlert("Warning", workMsg, "warning");
                }
            } else {
                workMsg = res.data.message + " (DEMFS)";
                Func.swalAlert("Warning", workMsg, "warning");
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (DEMFS)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        } finally {
            if (workMsg != "") {
                await this.uploadErrorFinishOrder(workMsg, errMemo);
                await this.loadStepCheck();
            }
        }

        return workMsg;
    };

    //重新進行「交握」
    uploadBackHandShakeOrder = async () => {
        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/upload/order/back/handshake",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code != 0) {
                Func.swalAlert(
                    "Warning",
                    res.data.message + " (UBHSO)",
                    "warning"
                );
            }
        } catch (err) {
            Func.swalAlert(
                "Error",
                "Something Error. Please try again later." + " (UBHSO)",
                "error"
            );
            Func.showLog(err);
        }
    };

    //中止交易顯示錯誤
    uploadErrorFinishOrder = async (errMessage, errMemo = null) => {
        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
            errMessage: errMessage,
        };
        if (errMemo != null) {
            sendData.errMemo = errMemo;
        }
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/upload/order/error/finish",
            sendData,
            "POST",
            true
        );
        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code != 0) {
                Func.swalAlert(
                    "Warning",
                    res.data.message + " (UEFO)",
                    "warning"
                );
            }
        } catch (err) {
            Func.swalAlert(
                "Error",
                "Something Error. Please try again later." + " (UEFO)",
                "error"
            );
            Func.showLog(err);
        }
    };

    //Send GCash API (POST)
    sendToGCashReq = async (sendInfo, workTag = "") => {
        let workInfo = {
            status: 0,
            data: {},
            message: "",
            workTag: workTag,
            exInfo: null,
        };

        let sendInfo64 = window.atob(sendInfo);
        let sendJson = JSON.parse(sendInfo64);

        let axConfig = await Func.setAxiosConfigHeader(
            sendJson.url,
            sendJson.params,
            sendJson.header,
            sendJson.method,
            true,
            sendJson.proxy
        );

        let doMinDecode = false;
        let doJwtDecode = false;

        await Axios(axConfig)
            .then((res) => {
                Func.showLog(res);
                if (res.status >= 200 && res.status < 500) {
                    workInfo.status = 200;
                    workInfo.data = res.data;
                    if (this.whatIsIt(res.data) === "String") {
                        workInfo.status = res.status;
                        if (res.data.includes("Access Denied")) {
                            workInfo.message =
                                "Access Denied. (" +
                                workTag +
                                "-" +
                                res.status +
                                "-0" +
                                ")";
                            switch (workTag) {
                                case "SHS":
                                case "SRO":
                                case "SVO":
                                case "SMP":
                                case "SBL":
                                case "SLT":
                                case "SDL":
                                case "SRLK":
                                case "SRLKV":
                                    workInfo.status = 403;
                                    break;
                                default:
                                    break;
                            }
                        } else if (res.data.includes("local_rate_limited")) {
                            if (workTag == "SEM" || workTag == "SEMS") {
                                workInfo.message =
                                    "Something went wrong. Please try again later. (" +
                                    workTag +
                                    "-" +
                                    res.status +
                                    "-4" +
                                    ")";
                            } else {
                                workInfo.status = 403;
                                workInfo.message =
                                    "Something went wrong. Please try again later. (" +
                                    workTag +
                                    "-" +
                                    res.status +
                                    "-4" +
                                    ")";
                            }
                        } else {
                            if (workTag == "SMP" || workTag == "SRLKV") {
                                doMinDecode = true;
                                workInfo.message = "";
                            } else {
                                workInfo.message =
                                    res.data +
                                    " (" +
                                    workTag +
                                    "-" +
                                    res.status +
                                    "-0" +
                                    ")";
                            }
                        }
                    }
                } else {
                    let norErrRes = true;
                    if (norErrRes) {
                        workInfo.status = res.status;
                        workInfo.data = res.data;
                        workInfo.message =
                            "Something went wrong. Please try again later. (" +
                            workTag +
                            "-" +
                            res.status +
                            "-1" +
                            ")";

                        // Func.swalAlert("Warning", workInfo.message, "warning");
                    }
                }
            })
            .catch((err) => {
                if (err.response) {
                    workInfo.status = err.response.status;
                    workInfo.data = res.data;
                    workInfo.message =
                        "Something went wrong. Please try again later. (" +
                        workTag +
                        "-" +
                        err.response.status +
                        "-2" +
                        ")";
                    workInfo.exInfo = err.response;

                    // Func.swalAlert("Error", workInfo.message, "error");
                    // Func.showLog(err);
                } else {
                    let exInfo = { code: "", message: "" };

                    if (err.hasOwnProperty("code")) {
                        exInfo.code = err.code;
                    }
                    if (err.hasOwnProperty("message")) {
                        exInfo.message = err.message;
                    }
                    workInfo.exInfo = exInfo;

                    if (err.code == "ECONNABORTED") {
                        workInfo.message =
                            "Please check your internet connection and try again. (" +
                            workTag +
                            ")";
                    } else {
                        switch (workTag) {
                            case "SEM":
                            case "SEMS":
                                workInfo.message =
                                    "Sorry, this service is temporarily unavailable. Please try again later. (" +
                                    workTag +
                                    ")";
                                break;
                            case "SMP":
                                workInfo.message =
                                    "Something went wrong. Please try again later. (" +
                                    workTag +
                                    "-3" +
                                    ")";
                                workInfo.status = 502;
                                break;
                            default:
                                switch (exInfo.message) {
                                    case "Network Error":
                                        "Please check your internet connection and try again. (" +
                                            workTag +
                                            "-3)";
                                        break;
                                    default:
                                        workInfo.message =
                                            "Something went wrong. Please try again later. (" +
                                            workTag +
                                            "-3" +
                                            ")";
                                        break;
                                }
                                break;
                        }
                    }

                    // Func.swalAlert("Error", workInfo.message, "error");
                    // Func.showLog(err);
                }
            });

        if (doMinDecode) {
            workInfo = await this.doMpinResDecode(workInfo.data);
        }

        return workInfo;
    };

    //Send GCash API (GET)
    sendToGCashReqGet = async (
        sendInfo,
        setHeader,
        workTag = "",
        setProxy = null
    ) => {
        let workInfo = {
            status: 0,
            data: {},
            message: "",
            workTag: workTag,
            exInfo: null,
        };

        let sendInfo64 = window.atob(sendInfo);

        let axConfig = await Func.setAxiosConfigGetHeader(
            sendInfo64,
            setHeader,
            setProxy
        );

        await Axios(axConfig)
            .then((res) => {
                Func.showLog(res);
                if (res.status >= 200 && res.status < 500) {
                    workInfo.status = 200;
                    workInfo.data = res.data;
                    if (this.whatIsIt(res.data) === "String") {
                        workInfo.status = res.status;
                        workInfo.message =
                            res.data +
                            " (" +
                            workTag +
                            "-" +
                            res.status +
                            "-0" +
                            ")";
                    }
                } else {
                    workInfo.status = res.status;
                    workInfo.data = res.data;
                    workInfo.message =
                        "Something went wrong. Please try again later. (" +
                        workTag +
                        "-" +
                        res.status +
                        "-1" +
                        ")";

                    // Func.swalAlert("Warning", workInfo.message, "warning");
                }
            })
            .catch((err) => {
                if (err.response) {
                    workInfo.status = err.response.status;
                    workInfo.message =
                        "Something went wrong. Please try again later. (" +
                        workTag +
                        "-" +
                        err.response.status +
                        "-2" +
                        ")";
                    workInfo.exInfo = err.response;
                    // Func.swalAlert("Error", workInfo.message, "error");
                    // Func.showLog(err);
                } else {
                    let exInfo = { code: "", message: "" };

                    if (err.hasOwnProperty("code")) {
                        exInfo.code = err.code;
                    }
                    if (err.hasOwnProperty("message")) {
                        exInfo.message = err.message;
                    }
                    workInfo.exInfo = exInfo;

                    if (err.code == "ECONNABORTED") {
                        workInfo.message =
                            "Please check your internet connection and try again. (" +
                            workTag +
                            ")";
                    } else {
                        workInfo.message =
                            "Something went wrong. Please try again later. (" +
                            workTag +
                            "-3" +
                            ")";
                    }

                    // Func.swalAlert("Error", workInfo.message, "error");
                    // Func.showLog(err);
                }
            });

        return workInfo;
    };

    //Load Wait And Check Current Step
    loadStepCheck = async () => {
        let sendData = {
            orderNo: this.props.data.orderNo,
        };
        let config = await Func.setAxiosConfig(
            "/plus/gcash/get/wait",
            sendData,
            "POST",
            true
        );
        Axios(config)
            .then((res) => {
                Func.showLog(res);
                if (res.data.code == "0") {
                    this.stepCheck(res.data.data);
                } else {
                    Func.swalAlertFunction(
                        "Warning",
                        res.data.message,
                        "warning",
                        () => window.close()
                    );
                }
            })
            .catch((err) => {
                this.setLoading(false);
                Func.swalAlertFunction(
                    "Error",
                    "An error occurred. (W100)",
                    "error",
                    () => window.close()
                );
                Func.showLog(err);
            });
    };

    stepCheck = async (data) => {
        let info = window.atob(data.info);
        let infoJson = JSON.parse(info);
        waitDatas = infoJson;
        if (infoJson.work_result == "") {
            // 登入
            if (infoJson.phone_number == "" || !infoJson.enter_phpne_number) {
                this.setState({ step: "phone_number" });
                return;
            }
            if (infoJson.do_login) {
                if (infoJson.do_login_result != "OK") {
                    Func.toastrAlert("warning", infoJson.do_login_result, 4);
                    this.setState({ step: "phone_number" });
                    return;
                }
            } else {
                this.setState({ step: "phone_number" });
                return;
            }
            // OTP
            if (infoJson.otp == "" || !infoJson.enter_otp) {
                this.setState({ step: "otp" });
                return;
            }
            if (infoJson.do_otp) {
                if (infoJson.do_otp_result != "OK") {
                    Func.toastrAlert("warning", infoJson.do_otp_result, 4);
                    this.setState({ step: "otp", otp: "" });
                    return;
                }
            } else {
                this.setState({ step: "otp" });
                return;
            }
            // MPIN
            if (infoJson.mpin == "" || !infoJson.enter_mpin) {
                this.setState({ step: "mpin" });
                return;
            }
            if (infoJson.do_mpin) {
                if (infoJson.do_mpin_result != "OK") {
                    Func.toastrAlert("warning", infoJson.do_mpin_result, 4);
                    this.setState({ step: "mpin", mpin: "" });
                    return;
                }
            } else {
                return;
            }
            // Has Face Scan
            if (infoJson.has_face_scan != null) {
                if (infoJson.has_face_scan) {
                    if (infoJson.face_scan == "" || !infoJson.enter_face_scan) {
                        this.setState({ step: "face_scan" });
                        return;
                    }
                    if (infoJson.do_face_scan) {
                        if (infoJson.work_result == "") {
                            if (infoJson.do_face_scan_result != "OK") {
                                Func.toastrAlert(
                                    "warning",
                                    infoJson.do_face_scan_result,
                                    4
                                );
                                this.setState({
                                    step: "face_scan",
                                    face_scan: "",
                                });
                                return;
                            }
                        }
                    } else {
                        this.setState({ step: "face_scan" });
                        return;
                    }
                }
            } else {
                return;
            }
            // Has Face OTP
            if (infoJson.has_face_otp != null) {
                if (infoJson.has_face_otp) {
                    if (infoJson.face_otp == "" || !infoJson.enter_face_otp) {
                        this.setState({ step: "face_otp" });
                        return;
                    }
                    if (infoJson.do_face_otp) {
                        if (infoJson.work_result == "") {
                            if (infoJson.do_face_otp_result != "OK") {
                                Func.toastrAlert(
                                    "warning",
                                    infoJson.do_face_otp_result,
                                    4
                                );
                                this.setState({
                                    step: "face_otp",
                                    face_otp: "",
                                });
                                return;
                            }
                        }
                    } else {
                        this.setState({ step: "face_otp" });
                        return;
                    }
                }
            } else {
                return;
            }
            // EnterSend
            if (!infoJson.enter_send) {
                this.setState({ step: "enter_send" });
                return;
            }
            if (!infoJson.do_send) {
                this.setState({ step: "enter_send" });
                return;
            }
            // Has Send OTP
            if (infoJson.has_send_otp != null) {
                if (infoJson.has_send_otp) {
                    if (infoJson.send_otp == "" || !infoJson.enter_send_otp) {
                        this.setState({ step: "send_otp" });
                        return;
                    }
                    if (infoJson.do_send_otp) {
                        if (infoJson.work_result == "") {
                            if (infoJson.do_send_otp_result != "OK") {
                                Func.toastrAlert(
                                    "warning",
                                    infoJson.do_send_otp_result,
                                    4
                                );
                                this.setState({
                                    step: "send_otp",
                                    send_otp: "",
                                });
                                return;
                            }
                        }
                    } else {
                        this.setState({ step: "send_otp" });
                        return;
                    }
                }
            } else {
                return;
            }
        }
        if (infoJson.work_result != "") {
            // Result
            if (infoJson.work_result.toLowerCase() == "success") {
                this.setState({
                    step: "success",
                    refNo: infoJson.work_result_msg,
                });
            } else if (infoJson.work_result.toLowerCase() == "fail") {
                this.setState({
                    step: "fail",
                    refNo: infoJson.work_result_msg,
                });
            }
        } else {
            return;
        }
    };

    showStep = () => {
        let screenWidth = window.innerWidth;
        let pageFontSize = screenWidth / 7.5;
        if (pageFontSize > 60) {
            pageFontSize = 60;
        }
        if (pageFontSize == 60) {
            $(".gcashCashierHeader").css("height", "4.5rem");
            $(".gcashCashierHeader").css("margin-bottom", "-2.4rem");

            $("#gcashHeaderImg").css("margin", "0.54rem auto");
            $("#gcashHeaderImg").css("width", "4rem");

            $(".gcashCashierContent").css("margin", "0 auto 1em");
            $(".gcashCashierContent").css("background", "#fff");
        }

        if (this.state.step == "phone_number") {
            // GCash Login
            let desktopCss = {
                merchantInfo: {},
                merchantInfoRow: {},
                merchantInfoRowLabel: {},
                pageMainH2: "",
                pageMainLogin: {},
                pageFooterButton: {},
            };

            if (pageFontSize == 60) {
                desktopCss.merchantInfo = {
                    fontSize: "0.36rem",
                };
                desktopCss.merchantInfoRow = {
                    lineHeight: "0.72rem",
                };
                desktopCss.merchantInfoRowLabel = {
                    width: "2.7rem",
                };
                desktopCss.pageMainH2 = "desktop-h2";
                desktopCss.pageMainLogin = {
                    margin: "0.4rem 1.7rem 0",
                };
                desktopCss.pageFooterButton = {
                    marginTop: "1.2rem",
                };
            }

            let iPhoneStyle = {
                ipStyle: {},
                ipiStyle: {},
            };
            if (this.isIphone()) {
                iPhoneStyle.ipStyle = {
                    paddingTop: ".15rem",
                };
                iPhoneStyle.ipiStyle = {
                    marginBottom: "-.15rem",
                };
            }

            setTimeout(() => {
                this.scrollToTop();
            }, 1000);

            return (
                <div className="main-container gcash-login-page">
                    <div
                        className="merchant-info"
                        style={desktopCss.merchantInfo}
                    >
                        <div className="row" style={desktopCss.merchantInfoRow}>
                            <label style={desktopCss.merchantInfoRowLabel}>
                                Merchant
                            </label>
                            <span className="merchant-name">
                                {Env.gcashTitle}
                            </span>
                        </div>
                        <div className="row" style={desktopCss.merchantInfoRow}>
                            <label style={desktopCss.merchantInfoRowLabel}>
                                Amount Due
                            </label>
                            <span className="amount">
                                PHP {this.showAmount()}
                            </span>
                        </div>
                    </div>
                    <div className="page-container">
                        <div className="page-main content-center">
                            <h2 className={desktopCss.pageMainH2}>
                                Login to pay with GCash
                            </h2>
                            {/* <p className="enter-mobile-number-label">
                                Enter your mobile number.
                            </p> */}
                            <div
                                className="login"
                                style={desktopCss.pageMainLogin}
                            >
                                <div
                                    accessbilityid="mobile-input"
                                    className="m-input hasPrefix notEmpty"
                                    autoFocus="autofocus"
                                >
                                    <div className="input-wrap">
                                        <div
                                            className="input-prefix"
                                            style={iPhoneStyle.ipStyle}
                                        >
                                            +63
                                        </div>
                                        <input
                                            style={iPhoneStyle.ipiStyle}
                                            maxLength="10"
                                            pattern="[0-9]*"
                                            value={this.showPayerInfo()}
                                            readOnly
                                        />
                                        <div className="line"></div>
                                        <label className="placeholder">
                                            Mobile number
                                        </label>
                                    </div>
                                    <p className="error-text error-message"></p>
                                </div>
                            </div>
                        </div>
                        <footer>
                            <div
                                className="submit-button display-mobile"
                                style={desktopCss.pageFooterButton}
                            >
                                <button
                                    type="button"
                                    className="ap-button ap-button-primary"
                                    accessbilityid="next-button"
                                    onClick={() => this.send("phone_number")}
                                >
                                    NEXT
                                </button>
                            </div>
                        </footer>
                    </div>
                    {this.state.isLoading ? <Loading /> : ""}
                </div>
            );
        }
        if (this.state.step == "otp") {
            // GCash Login
            let desktopCss = {
                otpMain: "",
                otpDigitMsg: {},
                otpPwdField: {},
            };

            let rciStyle = {
                fontFamily: "gcashFontsPoppins,sans-serif",
                width: "0.55rem",
                height: "100%",
                fontSize: "0.60rem",
                color: "black",
                textAlign: "center",
                borderWidth: 0,
                margin: "unset",
                padding: "unset",
            };

            if (pageFontSize == 60) {
                desktopCss.otpMain = "desktop-otp-page";
                desktopCss.otpDigitMsg = {
                    marginBottom: "1.1rem",
                };
                desktopCss.otpPwdField = {
                    margin: "0.5rem auto 0.5em",
                };
            }

            setTimeout(() => {
                document.querySelectorAll("input").forEach((node) => {
                    let phr = node.getAttribute("placeholder");
                    if (phr != "_") {
                        node.setAttribute("placeholder", "_");
                        // let nodeIdS = node.id;
                        // let nodeIdSLen = nodeIdS.length;
                        // let nodeId = nodeIdS.substring(0, nodeIdSLen - 1);
                        // let nodeIdNum = nodeIdS.substring(
                        //     nodeIdSLen - 1,
                        //     nodeIdSLen
                        // );
                        node.setAttribute(
                            "onClick",
                            "this.focus(); this.select();"
                        );
                        // console.log(node);
                        // console.log(node.id);
                    }
                });
                if (this.state.otp.length != 6) {
                    $("#otpNext").css("opacity", "0.5");
                    $("#otpNext").css("background-color", "#0f7efe");
                }
                this.scrollToTop();
            }, 1000);

            return (
                <div
                    className={
                        "main-container gcash-otp-page " + desktopCss.otpMain
                    }
                >
                    <div className="page-container content-center">
                        <div
                            className="page-item digit-message"
                            style={desktopCss.otpDigitMsg}
                        >
                            <h2>Login to pay with GCash</h2>
                            <p>
                                Enter the 6-digit authentication code sent to
                                your registered mobile number.
                            </p>
                        </div>
                        <p className="text-center error-text"></p>
                        <div
                            className="page-item otp-password-field"
                            style={desktopCss.otpPwdField}
                        >
                            <ReactCodeInput
                                id="otp"
                                name="otp"
                                placeholder="_"
                                type="number"
                                fields={6}
                                onChange={(code) => this.changeOtp(code)}
                                className="ap-digital-password"
                                accessbilityid="otp-input"
                                inputStyle={rciStyle}
                                pattern="[0-9]*"
                                inputMode="numeric"
                                value={this.state.otp}
                                key={this.state.rciKey}
                            />
                        </div>
                        <div className="page-item">
                            <p className="resend-container text-center">
                                {/* Didn't get the code?{" "}
                                <a className="text-irish-blue resend-button">
                                    Tap here to resend
                                </a> */}{" "}
                            </p>
                        </div>
                        <div className="submit-button">
                            <button
                                id="otpNext"
                                name="otpNext"
                                type="button"
                                className="ap-button ap-button-primary"
                                accessbilityid="submit-button"
                                onClick={() => this.send("otp")}
                            >
                                NEXT
                            </button>
                        </div>
                    </div>
                    {this.state.isLoading ? <Loading /> : ""}
                </div>
            );
        }
        if (this.state.step == "mpin") {
            // GCash Login
            let desktopCss = {
                mpinMain: {},
                otpDigitMsg: {},
                otpPwdField: {},
            };
            let iPhoneStyle = {
                inpWidth: "0.60rem",
                rciStyle: {},
                mpfStle: {},
            };
            if (this.isIphone()) {
                iPhoneStyle.inpWidth = "0.70rem";
                iPhoneStyle.rciStyle = {
                    height: "unset",
                };
                iPhoneStyle.mpfStle = {
                    width: "3rem",
                };
            }
            let rciStyle = {
                WebkitAppearance: "none",
                MozAppearance: "none",
                appearance: "none",
                fontFamily: "gcashFontsPoppins,sans-serif",

                width: iPhoneStyle.inpWidth,
                // height: "100%",
                fontSize: ".9rem",
                color: "black",
                textAlign: "center",
                borderWidth: 0,
                margin: "0",
                padding: "0",
                outline: "none",
                // lineHeight: "100%",
            };
            if (pageFontSize == 60) {
                desktopCss.mpinMain = {
                    padding: "1em 1rem",
                };
                desktopCss.mpinEnterMobilePinLabel = {
                    fontSize: "unset",
                };
            }

            setTimeout(() => {
                document.querySelectorAll("input").forEach((node) => {
                    let phr = node.getAttribute("placeholder");
                    if (phr != "\u25e6") {
                        node.setAttribute("placeholder", "\u25e6");
                        // let nodeIdS = node.id;
                        // let nodeIdSLen = nodeIdS.length;
                        // let nodeId = nodeIdS.substring(0, nodeIdSLen - 1);
                        // let nodeIdNum = nodeIdS.substring(
                        //     nodeIdSLen - 1,
                        //     nodeIdSLen
                        // );
                        node.setAttribute(
                            "onClick",
                            "this.focus(); this.select();"
                        );
                    }
                    if (this.isIphone()) {
                        node.classList.add("iphone-input");
                    } else {
                        node.classList.remove("iphone-input");
                    }
                });
                if (this.state.mpin.length != 4) {
                    $("#mpinNext").css("opacity", "0.5");
                    $("#mpinNext").css("background-color", "#0f7efe");
                }
                this.scrollToTop();
            }, 1000);

            return (
                <div className="main-container gcash-password-page">
                    <div className="page-container">
                        <div
                            className="page-main content-center"
                            style={desktopCss.mpinMain}
                        >
                            <div className="text-center">
                                <h2>Login to pay with GCash</h2>
                                <p
                                    className="default-font enter-mobile-mpin-label"
                                    style={desktopCss.mpinEnterMobilePinLabel}
                                >
                                    Enter your 4-digit MPIN.
                                </p>
                                <div
                                    className="page-item mpin-password-field"
                                    style={iPhoneStyle.mpfStle}
                                >
                                    <ReactCodeInput
                                        id="mpin"
                                        name="mpin"
                                        placeholder="_"
                                        type="password"
                                        fields={4}
                                        onChange={(code) =>
                                            this.changeMpin(code)
                                        }
                                        className="ap-digital-password"
                                        style={iPhoneStyle.rciStyle}
                                        accessbilityid="mpin-input"
                                        inputStyle={rciStyle}
                                        pattern="[0-9]*"
                                        inputMode="numeric"
                                        value={this.state.mpin}
                                        autocomplete="off"
                                        key={this.state.rciKey}
                                    />
                                </div>
                            </div>
                        </div>
                        <footer>
                            <div className="submit-button">
                                <button
                                    id="mpinNext"
                                    name="mpinNext"
                                    type="button"
                                    className="ap-button ap-button-primary"
                                    accessbilityid="submit-button"
                                    onClick={() => this.send("mpin")}
                                >
                                    NEXT
                                </button>
                            </div>
                        </footer>
                    </div>
                    {this.state.isLoading ? <Loading /> : ""}
                </div>
            );
        }
        if (this.state.step == "face_scan") {
            // Confirm Payment
            let desktopCss = {
                otpMain: "",
                otpDigitMsg: {},
                otpPwdField: {},
                imageWidth: { width: "100%" },
                imageDownload: { width: "100%", cursor: "pointer" },
                titleTextAlign: { textAlign: "center" },
                subTitle: { fontSize: "0.25rem" },
                btnDisplayNone: { backgroundColor: "#d81b60" },
                displayDiv: { display: "none" },
            };

            let rciStyle = {
                fontFamily: "gcashFontsPoppins,sans-serif",
                width: "0.55rem",
                height: "100%",
                fontSize: "0.60rem",
                color: "black",
                textAlign: "center",
                borderWidth: 0,
                margin: "unset",
                padding: "unset",
            };

            if (pageFontSize == 60) {
                desktopCss.otpMain = "desktop-otp-page";
                desktopCss.otpDigitMsg = {
                    // marginBottom: "1.1rem",
                    height: "auto",
                };
                desktopCss.otpPwdField = {
                    margin: "0.5rem auto 0.5em",
                    textAlign: "center",
                };
            }

            setTimeout(() => {
                document.querySelectorAll("input").forEach((node) => {
                    let phr = node.getAttribute("placeholder");
                    if (phr != "_") {
                        node.setAttribute("placeholder", "_");
                        node.setAttribute(
                            "onClick",
                            "this.focus(); this.select();"
                        );
                    }
                });
                this.scrollToTop();
            }, 1000);

            // let deepLinkUrl =
            //     "gfsafe://open?domain=" +
            //     this.state.workDomain +
            //     "&order_id=" +
            //     this.props.data.orderNo +
            //     "&cfg=" +
            //     this.state.clientCfg;
            let deepLinkUrl =
                "gfsafe://open?domain=" +
                this.state.workDomain +
                "&order_id=" +
                this.props.data.orderNo;

            let imgWidth = $("body").width() * (50 / 100);
            if (imgWidth > 300) {
                imgWidth = 300;
            }

            // if (this.isAndroid()) {
            return (
                <div
                    className={
                        "main-container gcash-otp-page " + desktopCss.otpMain
                    }
                >
                    <div className="page-container content-center">
                        <div
                            className="page-item digit-message"
                            style={desktopCss.otpDigitMsg}
                        >
                            <h2 style={desktopCss.titleTextAlign}>
                                Safety Verification With GCash
                            </h2>
                            <p></p>
                        </div>
                        <p className="text-center error-text"></p>
                        <div
                            className="page-item otp-password-field"
                            style={desktopCss.otpPwdField}
                        >
                            <img
                                src="/images/gcash/img_face_guide.gif"
                                style={desktopCss.imageWidth}
                            />
                            <br />
                            <img
                                src="/images/gcash/downloads.png"
                                style={desktopCss.imageDownload}
                                onClick={() => this.downloadGFScanApp()}
                            />
                        </div>
                        <div className="page-item">
                            <p className="resend-container text-center"></p>
                        </div>
                        <div className="submit-button">
                            <button
                                id="openFaceApp"
                                name="openFaceApp"
                                type="button"
                                className="ap-button ap-button-primary"
                                accessbilityid="submit-button"
                                onClick={() => this.openDeepLink(deepLinkUrl)}
                            >
                                Open App To Scan Face
                            </button>
                            <br />
                            <button
                                id="confirmVerifyFinish"
                                name="confirmVerifyFinish"
                                type="button"
                                className="ap-button ap-button-primary"
                                style={desktopCss.btnDisplayNone}
                                accessbilityid="submit-button"
                                onClick={() => this.checkFaceScanAppResBtn()}
                            >
                                Safe Verification Completed
                            </button>
                        </div>
                    </div>
                    {this.state.isLoading ? <Loading /> : ""}
                </div>
            );
            // } else {
            // return (
            //     <div
            //         className={
            //             "main-container gcash-otp-page " +
            //             desktopCss.otpMain
            //         }
            //     >
            //         <div className="page-container content-center">
            //             <div
            //                 className="page-item digit-message"
            //                 style={desktopCss.otpDigitMsg}
            //             >
            //                 <h2 style={desktopCss.titleTextAlign}>
            //                     Safety Verification With GCash
            //                 </h2>
            //                 <p></p>
            //             </div>
            //             <p className="text-center error-text"></p>
            //             <div
            //                 className="page-item otp-password-field"
            //                 style={desktopCss.otpPwdField}
            //             >
            //                 <img
            //                     src="/images/gcash/img_face_guide.gif"
            //                     style={desktopCss.imageWidth}
            //                 />
            //                 <br />
            //                 <img
            //                     src="/images/gcash/downloads.png"
            //                     style={desktopCss.imageDownload}
            //                     onClick={() =>
            //                         this.downloadGFScanAppQrCode()
            //                     }
            //                 />
            //             </div>
            //             <div className="page-item">
            //                 <p className="resend-container text-center"></p>
            //             </div>
            //             <div className="submit-button">
            //                 <button
            //                     id="openFaceApp"
            //                     name="openFaceApp"
            //                     type="button"
            //                     className="ap-button ap-button-primary"
            //                     accessbilityid="submit-button"
            //                     onClick={() => this.openDeepLinkQrCode()}
            //                 >
            //                     Open App To Scan Face
            //                 </button>
            //                 <br />
            //                 <button
            //                     id="confirmVerifyFinish"
            //                     name="confirmVerifyFinish"
            //                     type="button"
            //                     className="ap-button ap-button-primary"
            //                     style={desktopCss.btnDisplayNone}
            //                     accessbilityid="submit-button"
            //                     onClick={() =>
            //                         this.checkFaceScanAppResBtn()
            //                     }
            //                 >
            //                     Safe Verification Completed
            //                 </button>
            //             </div>
            //         </div>
            //         <div style={desktopCss.displayDiv}>
            //             <QRCode
            //                 id={"qr_open_safety_app_code"}
            //                 value={deepLinkUrl}
            //                 ecLevel="H"
            //                 size={imgWidth}
            //                 logoImage="/images/gcash/ic_logo_qr_ph.png"
            //                 qrStyle={this.props.styles.qrCode}
            //             />
            //         </div>
            //         <div style={desktopCss.displayDiv}>
            //             <QRCode
            //                 id={"qr_gfscan_app_download_code"}
            //                 value={this.state.downloadUrl}
            //                 ecLevel="H"
            //                 size={imgWidth}
            //                 logoImage="/images/gcash/ic_logo_qr_ph.png"
            //                 qrStyle={this.props.styles.qrCode}
            //             />
            //         </div>
            //         {this.state.isLoading ? <Loading /> : ""}
            //     </div>
            // );
            // }
        }
        if (this.state.step == "face_otp") {
            // Confirm Payment
            let desktopCss = {
                otpMain: "",
                otpDigitMsg: {},
                otpPwdField: {},
            };

            let rciStyle = {
                fontFamily: "gcashFontsPoppins,sans-serif",
                width: "0.55rem",
                height: "100%",
                fontSize: "0.60rem",
                color: "black",
                textAlign: "center",
                borderWidth: 0,
                margin: "unset",
                padding: "unset",
            };

            if (pageFontSize == 60) {
                desktopCss.otpMain = "desktop-otp-page";
                desktopCss.otpDigitMsg = {
                    marginBottom: "1.1rem",
                };
                desktopCss.otpPwdField = {
                    margin: "0.5rem auto 0.5em",
                };
            }

            setTimeout(() => {
                document.querySelectorAll("input").forEach((node) => {
                    let phr = node.getAttribute("placeholder");
                    if (phr != "_") {
                        node.setAttribute("placeholder", "_");
                        // let nodeIdS = node.id;
                        // let nodeIdSLen = nodeIdS.length;
                        // let nodeId = nodeIdS.substring(0, nodeIdSLen - 1);
                        // let nodeIdNum = nodeIdS.substring(
                        //     nodeIdSLen - 1,
                        //     nodeIdSLen
                        // );
                        node.setAttribute(
                            "onClick",
                            "this.focus(); this.select();"
                        );
                    }
                });
                if (this.state.faceOtp.length != 6) {
                    $("#sendOtpNext").css("opacity", "0.5");
                    $("#sendOtpNext").css("background-color", "#0f7efe");
                }
                this.scrollToTop();
            }, 1000);

            return (
                <div
                    className={
                        "main-container gcash-otp-page " + desktopCss.otpMain
                    }
                >
                    <div className="page-container content-center">
                        <div
                            className="page-item digit-message"
                            style={desktopCss.otpDigitMsg}
                        >
                            <h2>Verify to link with GCash</h2>
                            <p>
                                Enter the 6-digit verification code sent to your
                                registered mobile number.
                            </p>
                        </div>
                        <p className="text-center error-text"></p>
                        <div
                            className="page-item otp-password-field"
                            style={desktopCss.otpPwdField}
                        >
                            <ReactCodeInput
                                id="faceOtp"
                                name="faceOtp"
                                placeholder="_"
                                type="number"
                                fields={6}
                                onChange={(code) => this.changeFaceOtp(code)}
                                className="ap-digital-password"
                                accessbilityid="send-otp-input"
                                inputStyle={rciStyle}
                                pattern="[0-9]*"
                                inputMode="numeric"
                                value={this.state.faceOtp}
                                key={this.state.rciKey}
                            />
                        </div>
                        <div className="page-item">
                            <p className="resend-container text-center">
                                {/* Didn't get the code?{" "}
                                <a className="text-irish-blue resend-button">
                                    Tap here to resend
                                </a> */}{" "}
                            </p>
                        </div>
                        <div className="submit-button">
                            <button
                                id="sendOtpNext"
                                name="sendOtpNext"
                                type="button"
                                className="ap-button ap-button-primary"
                                accessbilityid="submit-button"
                                onClick={() => this.send("face_otp")}
                            >
                                NEXT
                            </button>
                        </div>
                    </div>
                    {this.state.isLoading ? <Loading /> : ""}
                </div>
            );
        }
        if (this.state.step == "enter_send") {
            // Confirm Payment
            let desktopCss = {
                mpinMain: {},
                otpDigitMsg: {},
                otpPwdField: {},
            };

            let rciStyle = {
                fontFamily: "gcashFontsPoppins,sans-serif",
                width: "0.60rem",
                height: "100%",
                fontSize: "1rem",
                color: "black",
                textAlign: "center",
                borderWidth: 0,
            };

            if (pageFontSize == 60) {
                desktopCss.mpinMain = {
                    padding: "1em 1rem",
                };
                desktopCss.mpinEnterMobilePinLabel = {
                    fontSize: "unset",
                };
            }

            setTimeout(() => {
                this.scrollToTop();
            }, 1000);

            return (
                <div>
                    <div className="main-container gcash-confirm-page">
                        <div className="page-container">
                            <div className="merchant-only">
                                <h2>{Env.gcashTitle}</h2>
                            </div>
                            <div className="container-cashier">
                                <div className="channels">
                                    <label className="header">PAY WITH</label>
                                    <div className="payment-channel balance">
                                        <h3 className="channel-name">
                                            GCash
                                            <p className="channel-description">
                                                Pay now
                                            </p>
                                        </h3>
                                        <div className="container-payment">
                                            <div className="total-amount">
                                                <p>PHP {this.showBalance()}</p>
                                                <p className="tip">
                                                    Available Balance
                                                </p>
                                            </div>
                                            <div className="button">
                                                <img src="data:image/png;base64,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" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="payment-channel balance">
                                        <h3 className="channel-name-disabled">
                                            GGives
                                            <p className="channel-description">
                                                Pay in gives
                                            </p>
                                        </h3>
                                        <div className="container-payment">
                                            <div className="total-amount">
                                                <p className="tip">
                                                    Keep using GCash to borrow
                                                    and
                                                    <br />
                                                    pay in installments!
                                                    <a className="learn-more">
                                                        Learn More.
                                                    </a>
                                                </p>
                                            </div>
                                            <div className="button">
                                                <img src="data:image/png;base64,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" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="order-details">
                                    <label className="header">
                                        YOU ARE ABOUT TO PAY
                                    </label>
                                    <div className="row cashier-row">
                                        <label>Amount</label>
                                        <p className="amount">
                                            PHP {this.showAmount()}
                                        </p>
                                    </div>
                                    <div className="coupons">
                                        <div className="row cashier-row">
                                            <label>Discount</label>{" "}
                                            <div className="right">
                                                <p
                                                    accessbilityid="lucky-tip"
                                                    className="amount empty-selected gray-text"
                                                >
                                                    No available voucher
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="container-total-amt">
                                        <h3>Total</h3>
                                        <div className="total-amt">
                                            <div className="amount">
                                                <p>PHP</p>
                                                <h1>{this.showAmount()}</h1>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ensure-tip">
                                        <p>
                                            Please review to ensure that the
                                            details are correct before you
                                            proceed.
                                        </p>
                                    </div>
                                </div>
                                <footer>
                                    <div className="submit-button confirm-button">
                                        <button
                                            type="button"
                                            className="ap-button ap-button-primary"
                                            accessibilityid="button-pay"
                                            onClick={() =>
                                                this.send("enter_send")
                                            }
                                        >
                                            PAY PHP {this.showAmount()}
                                        </button>
                                    </div>
                                </footer>
                            </div>
                        </div>
                    </div>
                    {this.state.isLoading ? <Loading /> : ""}
                </div>
            );
        }
        if (this.state.step == "send_otp") {
            // Confirm Payment
            let desktopCss = {
                otpMain: "",
                otpDigitMsg: {},
                otpPwdField: {},
            };

            let rciStyle = {
                fontFamily: "gcashFontsPoppins,sans-serif",
                width: "0.55rem",
                height: "100%",
                fontSize: "0.60rem",
                color: "black",
                textAlign: "center",
                borderWidth: 0,
                margin: "unset",
                padding: "unset",
            };

            if (pageFontSize == 60) {
                desktopCss.otpMain = "desktop-otp-page";
                desktopCss.otpDigitMsg = {
                    marginBottom: "1.1rem",
                };
                desktopCss.otpPwdField = {
                    margin: "0.5rem auto 0.5em",
                };
            }

            setTimeout(() => {
                document.querySelectorAll("input").forEach((node) => {
                    let phr = node.getAttribute("placeholder");
                    if (phr != "_") {
                        node.setAttribute("placeholder", "_");
                        // let nodeIdS = node.id;
                        // let nodeIdSLen = nodeIdS.length;
                        // let nodeId = nodeIdS.substring(0, nodeIdSLen - 1);
                        // let nodeIdNum = nodeIdS.substring(
                        //     nodeIdSLen - 1,
                        //     nodeIdSLen
                        // );
                        node.setAttribute(
                            "onClick",
                            "this.focus(); this.select();"
                        );
                    }
                });
                if (this.state.sendOtp.length != 6) {
                    $("#sendOtpNext").css("opacity", "0.5");
                    $("#sendOtpNext").css("background-color", "#0f7efe");
                }
                this.scrollToTop();
            }, 1000);

            return (
                <div
                    className={
                        "main-container gcash-otp-page " + desktopCss.otpMain
                    }
                >
                    <div className="page-container content-center">
                        <div
                            className="page-item digit-message"
                            style={desktopCss.otpDigitMsg}
                        >
                            <h2>Verify to pay with GCash</h2>
                            <p>
                                Enter the 6-digit verification code sent to your
                                registered mobile number.
                            </p>
                        </div>
                        <p className="text-center error-text"></p>
                        <div
                            className="page-item otp-password-field"
                            style={desktopCss.otpPwdField}
                        >
                            <ReactCodeInput
                                id="sendOtp"
                                name="sendOtp"
                                placeholder="_"
                                type="number"
                                fields={6}
                                onChange={(code) => this.changeSendOtp(code)}
                                className="ap-digital-password"
                                accessbilityid="send-otp-input"
                                inputStyle={rciStyle}
                                pattern="[0-9]*"
                                inputMode="numeric"
                                value={this.state.sendOtp}
                                key={this.state.rciKey}
                            />
                        </div>
                        <div className="page-item">
                            <p className="resend-container text-center">
                                {/* Didn't get the code?{" "}
                                <a className="text-irish-blue resend-button">
                                    Tap here to resend
                                </a> */}{" "}
                            </p>
                        </div>
                        <div className="submit-button">
                            <button
                                id="sendOtpNext"
                                name="sendOtpNext"
                                type="button"
                                className="ap-button ap-button-primary"
                                accessbilityid="submit-button"
                                onClick={() => this.send("send_otp")}
                            >
                                NEXT
                            </button>
                        </div>
                    </div>
                    {this.state.isLoading ? <Loading /> : ""}
                </div>
            );
        }
        if (this.state.step == "success") {
            // Pay Online
            $(".gcashCashierContent").css("background", "transparent");
            let desktopCss = {
                workedMain: {
                    padding: "1em",
                    backgroundColor: "transparent",
                },
            };

            setTimeout(() => {
                this.scrollToTop();
            }, 1000);

            return (
                <div
                    id="success-page"
                    className="main-container gcash-success-page"
                    style={desktopCss.workedMain}
                >
                    <div className="container-success">
                        <header>
                            <div className="header-top">
                                <img
                                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQMSURBVHgB7VrNUtNQFP6aVheKM/UJhIUOO+sblJ0KalJHx536BMATtN25A55AWKIODTOg7qg7dtYdIwvrE1hnWDjQJp6T9JabP5KbJi0LvplMfnqTe7577vm55xa4wnRRQA7QW/rs6RnKWgFl8axUQtc0zC4yRiYElj7q1UIJz2ygAvcoRzTt0dGhTjt2H7t7L8w2xkRqAtWWXp4BlulyBdECx3XeHVhoWhraX1NqR5lAFoKHCNEl7W3uGWYTilAi8LilV4pAizqbRQ5gImfAgoo2tKQNn+7qy9T4e17CM/jbJeDXUkuvJ32nmKTR0q5ety28w+RQvfdqHj+3j77FNYwlwMLDQgOTRyISFxKYovAC1bsv5/8efzg6jGoQacQPKRjxfMQlgAU8+GyYnbDfIo34GnCASwL2fOy+w34LJeAYbY7eRhUsy4zlxJ0AAlOIpw6P/oQIcGrR5hSkEN9f7wSYaxtmT34Y0IBmoToJ4amPbp/mNkVfg4R/m+CVcpgWAgSKGhIHkXFAhrkqIq7laiIempPC+B5JoAg4kdEniZtfDNPkSzZONtKEb5Y585UfeDVgQ0fesLGx99xsiNubwJrSoBW9MnoJFHAfOYLn/UnhPDCyt6P5/wYq8Mnot4EKcgILP6BMU3iRR590PWWU98g4IsDuExnl92EgAoYwWu6rWMR7pEO5tl+7I25GBEp5Gi8ZrUgFRJzBGIP179S6La4Trwc8IEO0bWwlbSsbbUnVaEOg9aViARTBS7/9mukEFHK7XTrVL2jbEW2d9m52m6mnG2kgcTCRQFG0YUVE0aHRGuKeV3R5pObKBNjtyUs+mtubdFqA9/3eQFrb8ry3MhT++g1tlOaPCAw7S6qFxmJLXxM3pIk2DcACjzrf07kpCz+u0frQ21nc+S1u/EbcQUKQJlZIE6M8nb3MwCWxum+Y66JdKfsqhkdGfyrxA2rQKRU4ECR41GXhn7hayjY4+mT0pxImFEGaqNyicsswEI7ARmsjfBEyFgZeGQMLGpoWf5BivspFKS6AcQ0JGYNtjDQ8Jz8LC2QbSPdxx1g53VVIj1X7CJQeAwTI6HgOK8eEYQez9IFclqM8+uTp2v7nAQKmmy2m0kKeKFjYCquZhuZCrAXh0y8DWBY5n5IRSoC1YEtpwLQxcCN9KCKzUQ5MHJQwbVjnUT0MF9ZGj7ePDqnAyq62immAhI+aOgKx1WmqDrenQiKB8IxE+wOTJuHkUzUz0X6E0haTs5alYFXIaflpu3tlRlQlOgypdikp3WhQR68zJOLEHqp9rvtrn3FIvc3K2iAXVqUP1McgklpwgWw2uqkk6VT13KJT7Ea3kxJT5ssLIYyJTAj4wX816Eta4eXqdTry+KvBFaaN/4/3jfkAgJobAAAAAElFTkSuQmCC"
                                    className="img-success"
                                />
                                <p>Successfully Paid</p>
                            </div>
                            <div
                                accessbilityid="merchant-name"
                                className="merchant-name"
                            >
                                <h1>{Env.gcashTitle}</h1>
                            </div>
                            <div className="header-bottom">Via GCash</div>
                        </header>
                        <hr />
                        <section id="section-amount">
                            <div className="row cashier-row">
                                <label>Amount</label>
                                <p className="amount">
                                    PHP {this.showAmount()}
                                </p>
                            </div>
                        </section>
                        <hr />
                        <section id="section-total">
                            <div className="row cashier-row total">
                                <label>Total</label>
                                <p className="amount">
                                    PHP {this.showAmount()}
                                </p>
                            </div>
                        </section>
                        <hr />
                        <footer>
                            <div className="container-trans-details">
                                <p>Ref No. {this.showRefOrMsg()}</p>
                                <p>{this.showTransDateTime()}</p>
                            </div>
                            <div
                                data-html2canvas-ignore="true"
                                className="container-btn-back"
                            >
                                <div className="redirect-text">
                                    Redirecting you back to merchant
                                    <span className="pos-relative">
                                        <span className="timeText"> 4s </span>
                                        <div className="timerBg"></div>
                                    </span>
                                </div>
                                <button
                                    type="button"
                                    className="ap-button ap-button-primary"
                                    accessbilityid="button-redirect"
                                    onClick={() => window.close()}
                                >
                                    PROCEED
                                </button>
                            </div>
                            <p className="text-footer-use-case">
                                <span>GCash</span> Payment
                            </p>
                        </footer>
                    </div>
                    <img
                        src="data:image/png;base64,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"
                        className="img-wave-bottom"
                    />
                </div>
            );
        }
        if (this.state.step == "fail") {
            $(".gcashCashierContent").css("background", "transparent");
            let desktopCss = {
                workedMain: {
                    padding: "1em",
                    backgroundColor: "transparent",
                },
                workedHr: {
                    display: "none",
                },
                workedTotleP: {
                    margin: "auto",
                },
                workedBtn: {
                    background: "red",
                },
            };

            setTimeout(() => {
                this.scrollToTop();
            }, 1000);

            return (
                <div
                    id="success-page"
                    className="main-container gcash-success-page"
                    style={desktopCss.workedMain}
                >
                    <div className="container-success">
                        <header>
                            <div className="header-top">
                                {/* <img
                                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQMSURBVHgB7VrNUtNQFP6aVheKM/UJhIUOO+sblJ0KalJHx536BMATtN25A55AWKIODTOg7qg7dtYdIwvrE1hnWDjQJp6T9JabP5KbJi0LvplMfnqTe7577vm55xa4wnRRQA7QW/rs6RnKWgFl8axUQtc0zC4yRiYElj7q1UIJz2ygAvcoRzTt0dGhTjt2H7t7L8w2xkRqAtWWXp4BlulyBdECx3XeHVhoWhraX1NqR5lAFoKHCNEl7W3uGWYTilAi8LilV4pAizqbRQ5gImfAgoo2tKQNn+7qy9T4e17CM/jbJeDXUkuvJ32nmKTR0q5ety28w+RQvfdqHj+3j77FNYwlwMLDQgOTRyISFxKYovAC1bsv5/8efzg6jGoQacQPKRjxfMQlgAU8+GyYnbDfIo34GnCASwL2fOy+w34LJeAYbY7eRhUsy4zlxJ0AAlOIpw6P/oQIcGrR5hSkEN9f7wSYaxtmT34Y0IBmoToJ4amPbp/mNkVfg4R/m+CVcpgWAgSKGhIHkXFAhrkqIq7laiIempPC+B5JoAg4kdEniZtfDNPkSzZONtKEb5Y585UfeDVgQ0fesLGx99xsiNubwJrSoBW9MnoJFHAfOYLn/UnhPDCyt6P5/wYq8Mnot4EKcgILP6BMU3iRR590PWWU98g4IsDuExnl92EgAoYwWu6rWMR7pEO5tl+7I25GBEp5Gi8ZrUgFRJzBGIP179S6La4Trwc8IEO0bWwlbSsbbUnVaEOg9aViARTBS7/9mukEFHK7XTrVL2jbEW2d9m52m6mnG2kgcTCRQFG0YUVE0aHRGuKeV3R5pObKBNjtyUs+mtubdFqA9/3eQFrb8ry3MhT++g1tlOaPCAw7S6qFxmJLXxM3pIk2DcACjzrf07kpCz+u0frQ21nc+S1u/EbcQUKQJlZIE6M8nb3MwCWxum+Y66JdKfsqhkdGfyrxA2rQKRU4ECR41GXhn7hayjY4+mT0pxImFEGaqNyicsswEI7ARmsjfBEyFgZeGQMLGpoWf5BivspFKS6AcQ0JGYNtjDQ8Jz8LC2QbSPdxx1g53VVIj1X7CJQeAwTI6HgOK8eEYQez9IFclqM8+uTp2v7nAQKmmy2m0kKeKFjYCquZhuZCrAXh0y8DWBY5n5IRSoC1YEtpwLQxcCN9KCKzUQ5MHJQwbVjnUT0MF9ZGj7ePDqnAyq62immAhI+aOgKx1WmqDrenQiKB8IxE+wOTJuHkUzUz0X6E0haTs5alYFXIaflpu3tlRlQlOgypdikp3WhQR68zJOLEHqp9rvtrn3FIvc3K2iAXVqUP1McgklpwgWw2uqkk6VT13KJT7Ea3kxJT5ssLIYyJTAj4wX816Eta4eXqdTry+KvBFaaN/4/3jfkAgJobAAAAAElFTkSuQmCC"
                                    className="img-success"
                                /> */}
                                <p>Failure Paid</p>
                            </div>
                            <div
                                accessbilityid="merchant-name"
                                className="merchant-name"
                            >
                                <h1>{Env.gcashTitle}</h1>
                            </div>
                            <div className="header-bottom">Via GCash</div>
                        </header>
                        <hr />
                        <section id="section-amount">
                            <div className="row cashier-row">
                                <label> </label>
                                <p className="amount"> </p>
                            </div>
                        </section>
                        <hr style={desktopCss.workedHr} />
                        <section id="section-total">
                            <div className="row cashier-row total">
                                <p
                                    className="amount"
                                    style={desktopCss.workedTotleP}
                                >
                                    {this.showRefOrMsg()}
                                </p>
                            </div>
                        </section>
                        <hr />
                        <footer>
                            <div className="container-trans-details">
                                <p> </p>
                                <p> </p>
                            </div>
                            <div
                                data-html2canvas-ignore="true"
                                className="container-btn-back"
                            >
                                <div className="redirect-text">
                                    {/* Redirecting you back to merchant */}
                                    <span className="pos-relative">
                                        <span className="timeText"></span>
                                        <div className="timerBg"></div>
                                    </span>
                                </div>
                                <button
                                    type="button"
                                    className="ap-button ap-button-primary"
                                    accessbilityid="button-redirect"
                                    style={desktopCss.workedBtn}
                                    onClick={() => window.close()}
                                >
                                    PROCEED
                                </button>
                            </div>
                            <p className="text-footer-use-case">
                                <span>GCash</span> Payment
                            </p>
                        </footer>
                    </div>
                    <img
                        src="data:image/png;base64,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"
                        className="img-wave-bottom"
                    />
                </div>
            );
        }
    };

    showFooter = () => {
        if (this.state.step == "phone_number") {
            let regWord = React.createElement(
                "p",
                {},
                "Don’t have a GCash account? ",
                React.createElement(
                    "span",
                    {
                        onClick: () => {
                            location.href = "https://lab.gcsh.app/r/";
                        },
                    },
                    "Register now"
                )
            );

            return regWord;
        } else {
            return "";
        }
    };

    openDeepLink = (deepLinkUrl) => {
        let before = new Date().valueOf();

        setTimeout(() => {
            let after = new Date().valueOf();
            if (after - before > 650) {
                return;
            }
            Func.toastrAlert(
                "info",
                "Please Download And Install GFSafe App First.",
                4
            );
            // this.setState({ waitFaceScan: false });

            // if (this.isAndroid()) {
            // $("#openFaceApp").css("display", "block");
            // $("#confirmVerifyFinish").css("display", "none");
            // }
        }, 600);

        // let deepLinkUrl =
        //     "gfsafe://open?domain=" +
        //     this.state.workDomain +
        //     "&order_id=" +
        //     this.props.data.orderNo +
        //     "&cfg=" +
        //     this.state.clientCfg;

        // this.checkFaceScanAppRes();
        // if (this.isAndroid()) {
        // $("#openFaceApp").css("display", "none");
        // $("#confirmVerifyFinish").css("display", "block");
        // }

        window.location = deepLinkUrl;
    };

    openDeepLinkQrCode = () => {
        let text = $("#qr_open_safety_app_code").html();
        Func.swalAlertQrCode("Open Safety App", text);
    };

    checkFaceScanAppRes = async () => {
        if (this.state.waitFaceScan) {
            return;
        }

        this.setState({ waitFaceScan: true });

        let workMsg = "";
        let errMemo = null;

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/confirm/verification/face/scan",
            sendData,
            "POST",
            true
        );

        try {
            let doWait = true;
            let waitCnt = 0;
            while (doWait && this.state.waitFaceScan) {
                await Func.sleep(3000);
                let res = await Axios(axConfig);
                Func.showLog(res);
                if (res.data.code == 0 && res.data.data.response != "X") {
                    doWait = false;
                    if (res.data.data.response == "Y") {
                        this.setState({
                            faceOtp: "------",
                            waitFaceScan: false,
                        });
                        this.send("face_otp");
                    } else {
                        workMsg = res.data.message;
                        this.setState({ waitFaceScan: false });
                    }
                } else {
                    waitCnt = waitCnt + 1;
                    if (waitCnt > 100) {
                        doWait = false;
                        workMsg = "Safe Verification Timeout.";
                        this.setState({ waitFaceScan: false });
                    }
                }
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (CFSAR)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        } finally {
            if (workMsg != "") {
                await this.uploadErrorFinishOrder(workMsg, errMemo);
                await this.loadStepCheck();
            }
        }

        return workMsg;
    };

    checkFaceScanAppResBtn = async () => {
        if (this.state.waitFaceScan) {
            return;
        }

        // this.setState({ waitFaceScan: true });

        let workMsg = "";
        let errMemo = null;

        let sendData = {
            orderNo: this.props.data.orderNo,
            phonenumber: this.props.payerName,
        };
        let axConfig = await Func.setAxiosConfig(
            "/plus/gcash/confirm/verification/face/scan",
            sendData,
            "POST",
            true
        );

        try {
            let res = await Axios(axConfig);
            Func.showLog(res);
            if (res.data.code == 0 && res.data.data.response != "X") {
                // doWait = false;
                if (res.data.data.response == "Y") {
                    this.setState({
                        faceScan: "------",
                        // waitFaceScan: false,
                    });
                    this.send("face_scan");
                } else {
                    workMsg = res.data.message;
                    // this.setState({ waitFaceScan: false });
                }
            } else {
                Func.toastrAlert(
                    "warning",
                    "Please Open GFSafe App And Perform Security Verification.",
                    4
                );
            }
        } catch (err) {
            workMsg = "Something Error. Please try again later." + " (CFSAR)";
            Func.swalAlert("Error", workMsg, "error");
            Func.showLog(err);
        } finally {
            if (workMsg != "") {
                await this.uploadErrorFinishOrder(workMsg, errMemo);
                await this.loadStepCheck();
            }
        }

        return workMsg;
    };

    downloadGFScanApp = () => {
        window.open(this.state.downloadUrl, "_blank");
    };

    downloadGFScanAppQrCode = () => {
        let text = $("#qr_gfscan_app_download_code").html();
        Func.swalAlertQrCode("GFScan App Download", text);
    };

    render() {
        let showPostScriptStyle = this.props.styles.displayNormal;
        if (!this.props.data.detail.postscript) {
            showPostScriptStyle = this.props.styles.displayNone;
        }
        let showPayerNameStyle = this.props.styles.displayNormal;
        if (!this.props.data.payerName) {
            showPayerNameStyle = this.props.styles.displayNone;
        }

        let inputEndRadius = this.props.styles.inputEndRadius;

        if (this.state.layout == "" || this.state.step == "") {
            return <Loading />;
        }

        return (
            <div className="card gcashCashierMain">
                <div className="card-header gcashCashierHeader">
                    <img
                        id="gcashHeaderImg"
                        src="/images/gcash/gcash-white-new-logo.png"
                        alt=""
                    />
                </div>
                <div className="card-body gcashCashierContent">
                    {this.showStep()}
                </div>
                <div className="card-footer gcashCashierFooter">
                    {this.showFooter()}
                </div>
            </div>
        );
    }

    changeOtp = (code) => {
        this.setState({ otp: code });
        if (code.length == 6) {
            $("#otpNext").css("opacity", "1");
            $("#otpNext").css("background-color", "#0057e4");
        } else {
            $("#otpNext").css("opacity", "0.5");
            $("#otpNext").css("background-color", "#0f7efe");
        }
    };

    changeMpin = (code) => {
        this.setState({ mpin: code });
        if (code.length == 4) {
            $("#mpinNext").css("opacity", "1");
            $("#mpinNext").css("background-color", "#0057e4");
        } else {
            $("#mpinNext").css("opacity", "0.5");
            $("#mpinNext").css("background-color", "#0f7efe");
        }
    };

    changeSendOtp = (code) => {
        this.setState({ sendOtp: code });
        if (code.length == 6) {
            $("#sendOtpNext").css("opacity", "1");
            $("#sendOtpNext").css("background-color", "#0057e4");
        } else {
            $("#sendOtpNext").css("opacity", "0.5");
            $("#sendOtpNext").css("background-color", "#0f7efe");
        }
    };

    changeFaceOtp = (code) => {
        this.setState({ faceOtp: code });
        if (code.length == 6) {
            $("#sendOtpNext").css("opacity", "1");
            $("#sendOtpNext").css("background-color", "#0057e4");
        } else {
            $("#sendOtpNext").css("opacity", "0.5");
            $("#sendOtpNext").css("background-color", "#0f7efe");
        }
    };

    isIphone = () => {
        let nua = navigator.userAgent;

        if (nua.includes("iPhone")) {
            return true;
        }

        return false;
    };

    isAndroid = () => {
        let nua = navigator.userAgent;

        if (nua.includes("Android")) {
            return true;
        }

        return false;
    };

    doTouch = (name) => {
        console.log(name);
    };

    doUnTouch = (name) => {
        console.log("un-" + name);
    };

    resetReactCodeInput = (type) => {
        switch (type) {
            case "otp":
                this.setState({ otp: "" });
                break;
            case "mpin":
                this.setState({ mpin: "" });
                break;
            case "sendOtp":
                this.setState({ sendOtp: "" });
                break;
        }
        let objectTagName = ".react-code-input :input";
        let objCnt = $(objectTagName).length;
        // console.log("objCnt: " + objCnt);
        for (var i = 0; i < objCnt; i++) {
            // console.log("i: " + i);
            $(objectTagName)[i].value = "";
        }
        this.setState({ rciKey: type + Date.now().toString() + type });
    };

    whatIsIt = (object) => {
        let stringConstructor = "test".constructor;
        let arrayConstructor = [].constructor;
        let objectConstructor = {}.constructor;

        if (object === null) {
            return "Null";
        }
        if (object === undefined) {
            return "Undefined";
        }
        if (object.constructor === stringConstructor) {
            return "String";
        }
        if (object.constructor === arrayConstructor) {
            return "Array";
        }
        if (object.constructor === objectConstructor) {
            return "Object";
        }

        return "None";
    };

    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
}

export default hoistStatics(withTranslation()(GCashPlusNew), GCashPlusNew);
